/* jshint ignore:start */

/* ====
====================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function( $ ) {
	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.

	var Sage = {
		// All pages
		'common': {
			init: function init() {

        var baseUrl = location.protocol + '//' + location.host;

				var scroll_to_top_button_handler = function scroll_to_top_button_handler() {
					var back_to_button_btn = $('.back-to-button a');

					$(window).scroll(function() {
						if ($(window).scrollTop() > 300) {
							back_to_button_btn.addClass('show');
						} else {
							back_to_button_btn.removeClass('show');
						}
					});

					back_to_button_btn.on('click', function(e) {
						e.preventDefault();
						$('html, body').animate({scrollTop:0}, '300');
					});
				};

				var move_account_portal_placeholder_top = function move_account_portal_placeholder_top() {
					var inputLabel = $( '.registration-form__label, .login-form__label, .forget-password-form__label, .reset-password-form__label, .save-filter-form__label, .text-box__label' );
					var inputField = $( '.registration-form__input, .login-form__input, .forget-password-form__input, .reset-password-form__input, .save-filter-form__input, .text-box__input' );

					inputLabel.click( function() {
						$( this ).parent().find( 'input' ).focus();
					} );

					inputField.focus( function() {
						$( this ).closest('div').find( 'label' ).addClass( 'move-placeholder-at-top' );
					} );

					inputField.blur( function() {
						var $this = $( this );
						if ( $this.val().length == 0 ) {
							$( this ).closest('div').find( 'label' ).removeClass( 'move-placeholder-at-top' );
						}
					} );

					inputField.blur();
				};

				var setMinMaxPriceSelect = function setMinMaxPriceSelect() {
					var minPrice = $( '#min-price' ),
						maxPrice = $( '#max-price' );

					minPrice.on( 'change', function() {

						maxPrice.children( "option" ).each( function() {
							var opt = $( this ),
								optVal = parseInt( opt.attr( 'value' ) );

							if ( optVal <= minPrice.val() ) {
								opt.attr( 'disabled', 'disabled' ).hide();
							} else {
								opt.removeAttr( 'disabled' ).show();
							}

						} );

					} );

					maxPrice.on( 'change', function() {

						minPrice.children( "option" ).each( function() {
							var opt = $( this ),
								optVal = parseInt( opt.attr( 'value' ) );

							if ( optVal != 0 && optVal >= maxPrice.val() ) {
								opt.attr( 'disabled', 'disabled' ).hide();
							} else {
								opt.removeAttr( 'disabled' ).show();
							}

						} );

					} );
				};

				var load_more_posts = function load_more_posts() {
					var container = document.querySelector( '#masonry-grid' );
					if ( container ) {
						/*if ( $( window ).width() >= 768 ) {
							var msnry = new Masonry( container, {
								itemSelector: '.col-12',
							} );
						}*/
					}

					$( '.load-more-posts' ).click( function() {

						var button = $( this ),
							data = {
								'action': 'loadmore',
								'query': sage_loadmore_params.posts, // that's how we get params from wp_localize_script() function
								'page': sage_loadmore_params.current_page
							};

						$.ajax( { // you can also use $.post here
							url: sage_loadmore_params.ajaxurl, // AJAX handler
							data: data,
							type: 'POST',
							beforeSend: function( xhr ) {
								button.text( 'Loading...' ); // change the button text, you can also add a preloader image
							},
							success: function( data ) {
								if ( data ) {
									button.text( 'Show More' );
									$( '.post-items' ).append( data );
									sage_loadmore_params.current_page++;
									/*if ( $( window ).width() >= 768 ) {
										var msnry = new Masonry( container, {
											itemSelector: '.col-12',
										} );
									}*/

									if ( sage_loadmore_params.current_page == sage_loadmore_params.max_page ) {
										button.remove();
									} // if last page, remove the button

									// you can also fire the "post-load" event here if you use a plugin that requires it
									// $( document.body ).trigger( 'post-load' );
								} else {
									button.remove(); // if no data, remove the button as well
								}
							}
						} );
					} );
				};

				// JavaScript to be fired on all pages
				var toggleMobileMenu = function toggleMobileMenu() {
					var mobileMenu = document.querySelector( '.header__navs' );
          var navsToggler = document.querySelector( '.header__navs-toggler' );
          if (navsToggler === null) {
            return;
          }

          navsToggler.addEventListener( 'click', function() {
						if ( this.getAttribute( 'aria-expanded' ) === 'false' ) {
							mobileMenu.classList.add( 'is-active' );
							this.setAttribute( 'aria-expanded', 'true' );
						} else {
							mobileMenu.classList.remove( 'is-active' );
							this.setAttribute( 'aria-expanded', 'false' );
							$( '.header__main-nav [aria-expanded="true"]' ).each( function(i, link ) {
								var iconClassList = link.lastChild.classList;
								link.setAttribute( 'aria-expanded', 'false' );
								iconClassList.remove( 'fa-chevron-down' );
								iconClassList.add( 'fa-chevron-right' );
							} );
						}
					} );
				};

				var toggleDropdownMenu = function toggleDropdownMenu() {
					var mainNav = document.querySelector( '.header__main-nav' );
          var bannerDiv = document.querySelector('.banner');
          if (mainNav === null) {
            return;
          }
          
					mainNav.addEventListener( 'click', function( e ) {

						var target = e.target;
						var nodeName = target.nodeName;
						var parentNode = target.parentNode;
						var lastChild = target.lastChild;

						if ( target && target.getAttribute( 'aria-expanded' ) === 'false' ) {
							$(parentNode.parentNode).find( '[aria-expanded="true"]' ).each( function(i, link ) {
								link.setAttribute( 'aria-expanded', 'false' );
								link.lastChild.classList.remove( 'fa-chevron-down' );
								link.lastChild.classList.add( 'fa-chevron-right' );
							} );
							target.setAttribute( 'aria-expanded', 'true' );
							lastChild.classList.remove( 'fa-chevron-right' );
							lastChild.classList.add( 'fa-chevron-down' );
							bannerDiv.style.pointerEvents = "none";
						} else if ( target && nodeName === 'SPAN' && parentNode.getAttribute( 'aria-expanded' ) === 'false' ) {
							$(parentNode.parentNode.parentNode).find( '[aria-expanded="true"]' ).each( function(i, link ) {
								link.setAttribute( 'aria-expanded', 'false' );
								link.lastChild.classList.remove( 'fa-chevron-down' );
								link.lastChild.classList.add( 'fa-chevron-right' );
							} );
							parentNode.setAttribute( 'aria-expanded', 'true' );
							target.classList.remove( 'fa-chevron-right' );
							target.classList.add( 'fa-chevron-down' );
							bannerDiv.style.pointerEvents = "none";
						} else if ( target && target.getAttribute( 'aria-expanded' ) === 'true' ) {
							target.setAttribute( 'aria-expanded', 'false' );
							lastChild.classList.remove( 'fa-chevron-down' );
							lastChild.classList.add( 'fa-chevron-right' );
							bannerDiv.style.pointerEvents = "all";
						} else if ( target && nodeName === 'SPAN' && parentNode.getAttribute( 'aria-expanded' ) === 'true' ) {
							parentNode.setAttribute( 'aria-expanded', 'false' );
							target.classList.remove( 'fa-chevron-down' );
							target.classList.add( 'fa-chevron-right' );
							bannerDiv.style.pointerEvents = "all";
						}
					} );
        };
        
        var closeAllOpenMainNavDropdowns = function closeAllOpenMainNavDropdowns() {
          $('.header__main-nav-link--has-dropdown[aria-expanded="true"]').each(function(i, link) {
            link.setAttribute('aria-expanded', 'false');
            link.lastChild.classList.remove('fa-chevron-down');
            link.lastChild.classList.add('fa-chevron-right');
          });
        };

				var toggleDropdown = function toggleDropdown() {
					$( '.dropdown-toggle' ).each( function(i, thisToggle ) {
						thisToggle.addEventListener( 'click', function() {
							var ariaExpanded = thisToggle.getAttribute( 'aria-expanded' );
							var thisDropdownMenu = thisToggle.nextElementSibling;

							if ( ariaExpanded === 'false' ) {
								$( thisDropdownMenu ).slideDown();
								thisToggle.setAttribute( 'aria-expanded', 'true' );
								var rightArrow = thisToggle.querySelector( '.fa-chevron-right' );

								if ( rightArrow !== null ) {
									rightArrow.classList.remove( 'fa-chevron-right' );
									rightArrow.classList.add( 'fa-chevron-down' );
								}

								$( '.dropdown-menu' ).each( function(i, menu ) {
									if ( menu !== thisDropdownMenu ) {
										$( menu ).slideUp();
										var toggle = menu.previousElementSibling;

										if ( toggle === null ) {
											return;
										}

										toggle.setAttribute( 'aria-expanded', 'false' );
										var downArrow = toggle.querySelector( '.fa-chevron-down' );

										if ( downArrow === null ) {
											return;
										}

										downArrow.classList.remove( 'fa-chevron-down' );
										downArrow.classList.add( 'fa-chevron-right' );
									}
								} );
							} else {
								$( thisDropdownMenu ).slideUp();
								thisToggle.setAttribute( 'aria-expanded', 'false' );
								var downArrow = thisToggle.querySelector( '.fa-chevron-down' );

								if ( downArrow !== null ) {
									downArrow.classList.remove( 'fa-chevron-down' );
									downArrow.classList.add( 'fa-chevron-right' );
								}
							}
						} );
					} );
				};

				var addHotSearchesMenu = function addHotSearchesMenu() {
					var hotSearches = window.hot_searches;
					var filterButtons = window.filter_buttons;

					var html = '';
					(filterButtons || []).forEach( function( filterButton ) {
						html += "<li class='menu-item menu-item-type-custom menu-item-object-custom header__main-nav-item'><a title=\"".concat( filterButton.filter_button_text, "\" href=\"" ).concat( filterButton.filter_button_url, "\" class=\"header__main-nav-submenu-link\">" ).concat( filterButton.filter_button_text, "</a></li>" );
					} );

					/*(hotSearches || []).forEach( function( hot_search ) {
						html += "<li class='menu-item menu-item-type-custom menu-item-object-custom header__main-nav-item'><a title=\"".concat( hot_search.hot_search_label, "\" href=\"" ).concat( hot_search.hot_search_url, "\" class=\"header__main-nav-submenu-link\">" ).concat( hot_search.hot_search_label, "</a></li>" );
					} );*/

					$( '.header__main-nav-link--has-dropdown[title="Popular Searches"] + .header__main-nav-submenu' ).html( html );
				};

				var handleLoginButtonClick = function handleLoginButtonClick() {
					var loginButton = document.querySelector( '.header__user-button--login' );

					if ( loginButton === null ) {
						return;
					}

					loginButton.addEventListener( 'click', function() {
						var overlay = document.querySelector( '.overlay' );
						var loginForm = document.querySelector( '.login-form' );

						if ( overlay === null || loginForm === null ) {
							return;
						}

						overlay.classList.add( 'is-active' );
						loginForm.classList.add( 'is-active' );
					} );
				};

				var handleLoginFormCloseButtonClick = function handleLoginFormCloseButtonClick() {
					var closeButton = document.querySelector( '.login-form__close-button' );

					if ( closeButton === null ) {
						return;
					}

					closeButton.addEventListener( 'click', function() {
						var overlay = document.querySelector( '.overlay' );
						var loginForm = document.querySelector( '.login-form' );
						var loginFormMessage = document.querySelector('.login-messages');

						if ( overlay === null || loginForm === null ) {
							return;
						}

						if ( overlay.classList.contains( 'is-active' ) ) {
							overlay.classList.remove( 'is-active' );
						}

						if ( loginForm.classList.contains( 'is-active' ) ) {
							loginForm.classList.remove( 'is-active' );
						}

						loginFormMessage.remove();

					} );
				};

				var handleRegisterButtonClick = function handleRegisterButtonClick() {
					var registerButton = document.querySelector( '.header__user-button--register' );

					if ( registerButton === null ) {
						return;
					}

					registerButton.addEventListener( 'click', function() {
						var overlay = document.querySelector( '.overlay' );
						var registrationForm = document.querySelector( '.registration-form' );

						if ( overlay === null || registrationForm === null ) {
							return;
						}

						overlay.classList.add( 'is-active' );
						registrationForm.classList.add( 'is-active' );
					} );
				};

				var handleFavoriteButtonClick = function handleFavoriteButtonClick() {
					$( document ).on( "click", '.favorite_link', function() {
						if ( !$( 'body' ).hasClass( 'logged-in' ) ) {
							$( '.overlay' ).addClass( 'is-active' );
							$( '.registration-form' ).addClass( 'is-active' );
							$('html, body').animate({scrollTop:0}, '300');
						} else {
							/*$('html, body').animate({scrollTop:0}, '300');*/
							/*showLoadingLogo();
							removeLoadingLogo();*/
						}
					} );
				};

				var handleRegistrationFormCloseButtonClick = function handleRegistrationFormCloseButtonClick() {
					var closeButton = document.querySelector( '.registration-form__close-button' );

					if ( closeButton === null ) {
						return;
					}

					closeButton.addEventListener( 'click', function() {
						var overlay = document.querySelector( '.overlay' );
						var registrationForm = document.querySelector( '.registration-form' );

						if ( overlay === null || registrationForm === null ) {
							return;
						}

						if ( overlay.classList.contains( 'is-active' ) ) {
							overlay.classList.remove( 'is-active' );
						}

						if ( registrationForm.classList.contains( 'is-active' ) ) {
							registrationForm.classList.remove( 'is-active' );
						}
					} );
				};

				var handleVideoEmbedButtonClick = function handleVideoEmbedButtonClick() {
					var videoLinkButton = document.querySelector( '.open-video-embed' );

					if ( videoLinkButton === null ) {
						return;
					}

					videoLinkButton.addEventListener( 'click', function() {
						var overlay = document.querySelector( '.overlay' );
						var videoEmbedDiv = document.querySelector( '.video-embed-popup' );

						if ( overlay === null || videoEmbedDiv === null ) {
							return;
						}
						$( "html, body" ).animate( { scrollTop: 0 } );
						overlay.classList.add( 'is-active' );
						videoEmbedDiv.classList.add( 'is-active' );

					} );
				};

				var handleVideoEmbedCloseButtonClick = function handleVideoEmbedCloseButtonClick() {
					var closeButton = document.querySelector( '.video-embed-popup__close-button' );

					if ( closeButton === null ) {
						return;
					}

					closeButton.addEventListener( 'click', function() {
						var overlay = document.querySelector( '.overlay' );
						var videoEmbedDiv = document.querySelector( '.video-embed-popup' );
						var iframePopup = document.querySelector( '.video-embed-popup__iframe' );
						var iframeURL = iframePopup.src;

						if ( overlay === null || videoEmbedDiv === null ) {
							return;
						}

						if ( overlay.classList.contains( 'is-active' ) ) {
							overlay.classList.remove( 'is-active' );
						}

						if ( videoEmbedDiv.classList.contains( 'is-active' ) ) {
							videoEmbedDiv.classList.remove( 'is-active' );
							iframePopup.src = '';
							iframePopup.src = iframeURL;
						}
					} );
				};

				var handleForgetPasswordFormCloseButtonClick = function handleForgetPasswordFormCloseButtonClick() {
					var closeButton = document.querySelector( '.forget-password-form__close-button' );

					if ( closeButton === null ) {
						return;
					}

					closeButton.addEventListener( 'click', function() {
						var overlay = document.querySelector( '.overlay' );
						var forgetPasswordForm = document.querySelector( '.forget-password-form' );

						if ( overlay === null || forgetPasswordForm === null ) {
							return;
						}

						if ( overlay.classList.contains( 'is-active' ) ) {
							overlay.classList.remove( 'is-active' );
						}

						if ( forgetPasswordForm.classList.contains( 'is-active' ) ) {
							forgetPasswordForm.classList.remove( 'is-active' );
						}
					} );
				};

				var handleResetPasswordFormCloseButtonClick = function handleResetPasswordFormCloseButtonClick() {
					var closeButton = document.querySelector( '.reset-password-form__close-button' );

					if ( closeButton === null ) {
						return;
					}

					closeButton.addEventListener( 'click', function() {
						var overlay = document.querySelector( '.overlay' );
						var forgetPasswordForm = document.querySelector( '.reset-password-form' );

						if ( overlay === null || forgetPasswordForm === null ) {
							return;
						}

						if ( overlay.classList.contains( 'is-active' ) ) {
							overlay.classList.remove( 'is-active' );
						}

						if ( forgetPasswordForm.classList.contains( 'is-active' ) ) {
							forgetPasswordForm.classList.remove( 'is-active' );
						}
					} );
				};

				var accountFormLinkClickHandler = function accountFormLinkClickHandler() {
					$( '.login-form__forgot-password-link' ).on( 'click', function( e ) {
						e.preventDefault();
						$( '.overlay, .login-form, .registration-form, .forget-password-form' ).removeClass( 'is-active' );
						$( '.overlay, .forget-password-form' ).addClass( 'is-active' );
					} );
					$( '.login-form__create-account-link' ).on( 'click', function( e ) {
						e.preventDefault();
						$( '.overlay, .login-form, .registration-form, .forget-password-form' ).removeClass( 'is-active' );
						$( '.overlay, .registration-form' ).addClass( 'is-active' );
					} );
					$( '.registration-form__login-link' ).on( 'click', function( e ) {
						e.preventDefault();
						$( '.overlay, .login-form, .registration-form, .forget-password-form' ).removeClass( 'is-active' );
						$( '.overlay, .login-form' ).addClass( 'is-active' );
					} );
				};

				var activateOrDeactivateVerticalSlider = function activateOrDeactivateVerticalSlider() {
					var $homeverticalSliderDiv = $( '.home-vertical-slider .vertical-slider-inner' );
					var homeslideDisplay = $homeverticalSliderDiv.find( '.home-vertical-slider__slide' ).css( 'display' );

					if (['block', 'inline-block'].includes(homeslideDisplay)) {
						if ( $homeverticalSliderDiv.hasClass( 'slick-initialized' ) ) {
							$homeverticalSliderDiv.slick( 'unslick' );
						}
					} else if ( !$homeverticalSliderDiv.hasClass( 'slick-initialized' ) ) {
						$homeverticalSliderDiv.slick( {
							arrows: false,
							fade: true,
							speed: 700,
						} );
					}

					var $innerPageVerticalSliderDiv = $( '.inner-page-vertical-slider .vertical-slider-inner' );
					var innerPageSlideDisplay = $innerPageVerticalSliderDiv.find( '.inner-page-vertical-slider__slide' ).css( 'display' );

					if ( ['block', 'inline-block'].includes(innerPageSlideDisplay)) {
            $innerPageVerticalSliderDiv.filter('.slick-initialized').slick( 'unslick' );
            $innerPageVerticalSliderDiv.find('.mCustomScrollbar').mCustomScrollbar('destroy');
					} else {
						$innerPageVerticalSliderDiv.not('.slick-initialized').slick( {
							arrows: false,
							fade: true,
							speed: 700,
            } );
            
            setScrollbarForVerticalSlider();
					}

				};

				var setScrollbarForVerticalSlider = function setScrollbarForVerticalSlider() {
					$( '.inner-page-vertical-slider__text-content:not(.mCustomScrollbar)' ).mCustomScrollbar( {
						scrollbarPosition: 'outside',
						alwaysShowScrollbar: 0,
						scrollButtons: {
							enable: true
						},
						keyboard: {
							enable: true
						},
						theme: 'inset-dark'
					} );
				};

				var setPlaceholderAtTop = function setPlaceholderAtTop() {
					var inputLabel = $( '.footer__contact-form-placeholder label' );
					var inputField = $( '.footer__contact-form-input, .footer__contact-form-textarea' );

					inputLabel.click( function() {
						$( this ).parents( '.form-group' ).find( 'input, textarea' ).focus();
					} );

					inputField.focus( function() {
						$( this ).parents( '.form-group' ).find( '.footer__contact-form-placeholder label' ).addClass( 'move-placeholder-at-top' );
					} );

					inputField.blur( function() {
						var $this = $( this );
						if ( $this.val().length == 0 ) {
							$( this ).parents( '.form-group' ).find( '.footer__contact-form-placeholder label' ).removeClass( 'move-placeholder-at-top' );
						}
					} );

					inputField.blur();
				};

				var timer;
				var resizeTimer;
				var ps = null;
				var lightBox = null;
				var xhrProperties = null;
				var xhrPropertiesByOpenDates = null;
				var xhrFilteredFavorites = null;
				var wplListingContainer = $( '.wpl_property_listing:not(.home) .wpl_property_listing_listings_container' );
				window.sr = ScrollReveal();
				window.hvs = ScrollReveal();
				window.ivs = ScrollReveal();

				var initAnimationinit = null;
				var revealHomeVerticalSliderItems = null;
				var revealInnerVerticalSliderItems = null;
				var revealSliderOptions = {
					easing: 'ease',
					distance: '15px',
					mobile: false,
					delay: 400,
					duration: 1000,
					reset: false,
				};

				var revealOptions = {
					easing: 'ease',
					distance: '15px',
					mobile: false,
					delay: 300,
					duration: 1000,
					reset: false,
					interval: 60
				};


				revealHomeVerticalSliderItems = function revealHomeVerticalSliderItems() {
					hvs.reveal('.home-vertical-slider__col--2-1 > *,' +
					           '.home-vertical-slider__col--2-2 > *,' +
					           '.home-vertical-slider__col--2 > *', revealSliderOptions );
				};

				revealInnerVerticalSliderItems = function revealInnerVerticalSliderItems() {
					ivs.reveal('.inner-page-vertical-slider__button, .inner-page-vertical-slider__text-content:not(.no-scroll-reveal) *:not(.mCS-inset-dark), ' +
					           '.meet-aubrey-guri-slides .content-box__col--right *', revealSliderOptions );
				};

				initAnimationinit = function initAnimationinit() {

					revealHomeVerticalSliderItems();
					revealInnerVerticalSliderItems();

					sr.reveal('header', revealOptions );
					sr.reveal('.banner', revealOptions );
					sr.reveal('.slogan__line--1, .slogan__line--2', revealOptions );
					sr.reveal('.banner__title-line-1, .banner__title-line-2', revealOptions );
					sr.reveal('.main__heading, .main__text > *, .website-categories, .post-items > *, /*.main__properties-slide *,*/ .reviews-box--list__list-quote > *, .lidd_mc_form > *,' +
					          '.wpl_prp_container_content .wpl_prp_container_content_title *,\n' +
					          '.wpl_prp_show_detail_boxes_title,\n' +
					          '.property-details-accordion-content .wpl-column', revealOptions);
					sr.reveal('.search, .search-form, .search-and-filter-bar', revealOptions );
					sr.reveal('.footer--child', revealOptions );
				};

				var closeDropdownOnBackgroundClick = function closeDropdownOnBackgroundClick() {
					$( 'body' ).on( 'click', function( e ) {
						var $toggle = $( e.target ).closest( '.header__main-nav-link--has-dropdown, .dropdown-toggle, .search-and-filter-bar__filter-toggle, .search-and-filter-bar__toggle-filters--mobile' );

						if ( $( e.target ).hasClass( 'select2-search__field' ) || $( e.target ).hasClass( 'select2-selection__rendered' ) || $( e.target ).hasClass( 'search-and-filter-bar__neighborhood-select' ) || $( e.target ).hasClass( 'search-and-filter-bar__filter-input--select' ) || $( e.target ).closest( '.search-and-filter-form__filters, .search-and-filter-form__filter-button' ).length > 0 ) {
							return;
						}

						$(".search-and-filter-bar__neighborhood-select, .search-and-filter-form__neighborhood-select").select2("close");

						if ( $toggle.length === 0 ) {
							$( '.search-and-filter-form__filters, .dropdown-menu:not(.search-and-filter-form__dropdown-menu)' ).slideUp();
							$( '.search-and-filter-form__filter-button[aria-expanded="true"]' ).attr( 'aria-expanded', 'false' );
							$( '.search-and-filter-bar__filter-col' ).removeClass( 'is-expanded' );
							$( '.search-and-filter-bar__toggle-filters--mobile' ).attr( 'aria-expanded', 'false' );
						} else if ( $toggle.closest( '.menu-primary-navigation-container' ).length > 0 ) {
							$( '.search-and-filter-bar .dropdown-menu' ).slideUp();
						} else if ( $toggle.closest( '.search-and-filter-bar' ).length > 0 ) {
							$( '.menu-primary-navigation-container' ).find( '.header__main-nav-link--has-dropdown[aria-expanded="true"]' )
								.attr( 'aria-expanded', 'false' )
								.find( 'span' ).removeClass( 'fa-chevron-down' ).addClass( 'fa-chevron-right' );
						}

						if ( $toggle.length === 0 || $toggle.closest( '.menu-primary-navigation-container' ).length > 0 ) {
							$( '.search-and-filter-bar' ).find( '.search-and-filter-bar__filter-toggle' ).attr( 'aria-expanded', 'false' ).find( 'span' ).removeClass( 'fa-chevron-down' ).addClass( 'fa-chevron-right' );
            }
            
            if ($toggle.length === 0 && e.target.closest('.header__main-nav-submenu') === null) {
              closeAllOpenMainNavDropdowns();
            }

					} );
				};

				var setMapCanvasHeight = function setMapCanvasHeight() {
					var $listingsContainer = $( '.wpl_property_listing_listings_container' );

					if ( $listingsContainer.length === 0 ) {
						return;
					}

					var mapContainerHeight = $listingsContainer.outerHeight() + 17;
					var $mapCanvas = $( '.wpl_map_canvas' );

					if ( ps !== null && mapContainerHeight > $mapCanvas.outerHeight() ) {
						$mapCanvas.outerHeight( mapContainerHeight );
					}
				};

				var formatPropertyLocationText = function formatPropertyLocationText() {
					$( '.wpl_prp_listing_location > span > span, .property__location, .main_infowindow_location' ).html( function( index, oldHtml ) {
						var addressArr = oldHtml.split( ', ' );

						if ( addressArr.length > 2 && $( this ).find( '.property-street-address' ).length === 0 ) {
							return "<span class=\"property-street-address\">".concat( addressArr[ 0 ], "</span><span class=\"property-separator\">, </span>" ) + "<span class=\"property-city\">".concat( addressArr[ 1 ], "</span><span class=\"property-separator\">, </span>" ) + "<span class=\"property-state-zip\">".concat( addressArr[ 2 ], "</span>" );
						}

						return oldHtml;
					} );
				};

				var infoWindowDOMReadyHandler = function infoWindowDOMReadyHandler() {
					var $mapContainer = $( '.wpl_googlemap_container' );

					if ( $mapContainer.length === 0 ) {
						return;
					}

					var mapId = $mapContainer.attr( 'id' ).replace( 'wpl_googlemap_container', '' );

					if ( typeof window[ "infowindow".concat( mapId ) ] !== 'undefined' ) {
						window.google.maps.event.addListener( window[ "infowindow".concat( mapId ) ], 'domready', function() {
							$mapContainer.find( '.wpl_gallery_image' ).attr( 'src', function( i, oldSrc ) {
								return oldSrc.replace( '180x125', '500x288' );
							} );
							formatPropertyLocationText();
						} );
					}
				};

				var addPhotosCount = function addPhotosCount() {
					$( 'a[href="#tabs-1"]' ).text( function() {
						var photosCount = $( this ).closest( '.tabs_box' ).prev( '.tabs_container' ).find( '.bxslider > li' ).length;
						return "".concat( photosCount, " Photos" );
					} );
				};

				var fadeInPropertiesOnImagesLoaded = function fadeInPropertiesOnImagesLoaded() {
					$( '.wpl_property_listing_list_view_container' ).imagesLoaded( function() {
						$( '.wpl_property_listing_list_view_container' ).addClass( 'is-loaded' );
					} );
				};

				var changePropertyListingPageHeader = function changePropertyListingPageHeader() {
					$( '.wpl_property_listing .page-header > h1' ).html( 'Browse Properties' );
				};

				/*var addBedroomsMultipleValuesToHiddenField = function addBedroomsMultipleValuesToHiddenField() {
					$( '.search-and-filter-form__bedrooms-checkbox, .search-and-filter-bar__bedrooms-checkbox' ).on( 'change', function() {
						var bedrooms = $( '.search-and-filter-form__bedrooms-checkbox:checked, .search-and-filter-bar__bedrooms-checkbox:checked' ).map( function() {
							return $( this ).val();
						} ).get().join( ',' );
						$( '.search-and-filter-form__multiple-bedrooms, .search-and-filter-bar__multiple-bedrooms' ).val( bedrooms ).trigger( 'change' );
					} );
				};*/

				var addBedroomsMultipleValuesToHiddenField = function addBedroomsMultipleValuesToHiddenField() {
					$('.search-and-filter-form__bedrooms-checkbox, .search-and-filter-bar__bedrooms-checkbox').on('change', function() {
						var bedrooms = $('.search-and-filter-form__bedrooms-checkbox:checked, .search-and-filter-bar__bedrooms-checkbox:checked').map(function() {
							return $(this).val();
						}).get();

						var firstVal = bedrooms[0] || '';
						var minBedrooms = firstVal.lastIndexOf('+') === firstVal.length - 1 ? firstVal.slice(0, -1) : firstVal;
						var lastVal = bedrooms[bedrooms.length - 1] || '';
						var maxBedrooms = lastVal.lastIndexOf('+') === lastVal.length - 1 ? '' : lastVal;
						$('.search-and-filter-form__min-bedrooms, .search-and-filter-bar__min-bedrooms').val(minBedrooms).trigger('change');
						$('.search-and-filter-form__max-bedrooms, .search-and-filter-bar__max-bedrooms').val(maxBedrooms).trigger('change');
					});
				};

				var addPropertyTypesMultipleValuesToHiddenField = function addPropertyTypesMultipleValuesToHiddenField() {
					$( '.search-and-filter-form__property-type-checkbox, .search-and-filter-bar__property-type-checkbox' ).on( 'change', function() {
						var propertyTypes = $( '.search-and-filter-form__property-type-checkbox:checked, .search-and-filter-bar__property-type-checkbox:checked' ).map( function() {
							return $( this ).val();
						} ).get().join( ',' );
						$( '.search-and-filter-form__property-types, .search-and-filter-bar__property-types' ).val( propertyTypes ).trigger( 'change' );
					} );
				};

				var initScrollbarForPropertyListings = function initScrollbarForPropertyListings() {
					$( '.wpl_pagination_container' ).appendTo( '.wpl_property_listing_listings_container' );
					if ( wplListingContainer.length > 0 && $( window ).width() >= 768 ) {
						ps = $( 'body:not(.exclusive-preview) .wpl_property_listing_listings_container' ).mCustomScrollbar( {
							scrollbarPosition: 'outside',
							alwaysShowScrollbar: 0,
							scrollButtons: {
								enable: true
							},
							keyboard: {
								enable: true
							},
							theme: 'inset-dark'
						} );

					} else if ( wplListingContainer.length > 0 && $( window ).width() < 768 ) {
						wplListingContainer.mCustomScrollbar( "destroy" );
						/*$('.wpl_property_listing_list_view_container > .wpl_pagination_container').hide();*/
					}
					setTimeout(function(){
						wplj( 'body').removeClass( 'is-loading-logo-visible' );
					}, 700);
				};

				var modifyAndMoveTotalResult = function modifyAndMoveTotalResult() {
					$( '.wpl_total_result' ).html( function( index, oldHtml ) {
						return oldHtml.replace( ' returned.', '' );
					} ).prependTo( '.wpl_googlemap_container' );
				};

				var addNoResultsHtml = function addNoResultsHtml() {
					var $totalResult = $( '.wpl_total_result' );

					if ( $totalResult.length === 0 ) {
						return;
					}

					var totalResult = +$totalResult.html().split( ' ' ).shift();

					if ( totalResult > 0 ) {
						return;
					}

					var html = "<p class=\"no-results-message\">There are currently no results for your search. Try these popular searches...\n    <div class=\"hot-searches-buttons\">";
					var filterButtons = window.filter_buttons;
					var count = 0;
					(filterButtons || []).forEach( function( filter_button ) {
						if ( count === 1 ) {
							var hotSearches = window.hot_searches;
							(hotSearches || []).forEach( function( hot_search ) {
								html += "<a type=\"button\" class=\"hot-searches__button button button--olive\" href=\"".concat( hot_search.hot_search_url, "\">" ).concat( hot_search.hot_search_label, "</a>" );
							} );
						}

						html += "<a type=\"button\" class=\"hot-searches__button button button--olive\" href=\"".concat( filter_button.filter_button_url, "\">" ).concat( filter_button.filter_button_text, "</a>" );
						count++;
					} );
					html += '</div>';
					$( '.wpl_property_listing_listings_container' ).prepend( html );
				};

				var searchAndFilterBarTextInputHandler = function searchAndFilterBarTextInputHandler() {
					$(document).on('keyup keypress', '.search-and-filter-bar__search-input', function(e) {
						if(e.keyCode === 13) {
							e.preventDefault();
							$( '.search-and-filter-bar__search-input' ).trigger("blur");
							$( '.search-and-filter-bar' ).addClass( 'text-search-filter-is-visible' );
							getProperties();
							return false;
						}
					});
				};

				var searchAndFilterBarInputChangeHandler = function searchAndFilterBarInputChangeHandler() {
					$( '.search-and-filter-bar__filter-input--select, .search-and-filter-bar input[name][type="radio"], .search-and-filter-bar input[name][type="checkbox"], ' + '.search-and-filter-bar input[name][type="hidden"], .aubrey-listings-only__checkbox' ).on( 'change', function() {
						getProperties();
					} );
        };
        
        var searchAndFilterBarSearchButtonClickHandler = function searchAndFilterBarSearchButtonClickHandler() {
          $('.search-and-filter-bar__search-button').on('click', function(e) {
            e.preventDefault();
            getProperties();
          });
        };

				var searchAndFilterFavoritesTextInputHandler = function searchAndFilterFavoritesTextInputHandler() {
					$( '.favorites .search-and-filter-form input[name][type="text"], .favorites .search-and-filter-form input[name][type="number"]' ).on( 'input', function() {
						getFilteredFavorites();
					} );
				};

				var searchAndFilterFavoritesInputChangeHandler = function searchAndFilterFavoritesInputChangeHandler() {
					$( '.favorites .search-and-filter-form input[name][type="radio"], .favorites .search-and-filter-form input[name][type="checkbox"], ' + '.favorites .search-and-filter-form input[name][type="hidden"]' ).on( 'change', function() {
						getFilteredFavorites();
					} );
				};

				var searchAndFilterFavoritesSearchButtonClickHandler = function searchAndFilterFavoritesSearchButtonClickHandler() {
					$( '.favorites .search-and-filter-form__search-button' ).on( 'click', function( e ) {
            if ($('.no-property-message').length > 0) {
              return;
            }

						e.preventDefault();
						getFilteredFavorites();
					} );
        };

				var formatPrice = function formatPrice( n ) {
					if ( !Number.isInteger( n ) ) {
						n = parseInt( n );
					}

					return "".concat( n / 1000, "K" );
				};

				var getPropertyType = function getPropertyType( id ) {
					var propertyTypes = {
						20: 'Single Family',
						19: 'Residential Rental',
						21: '2 Family',
						22: 'Vacant Land',
						28: 'Land/acreage',
						24: '3 Family +',
						23: 'Commercial',
						25: 'Business Opportunities',
						27: 'Motels/hotels',
						26: 'Industrial',
						29: 'Multiple Dwelling Units'
					};

					if ( id in propertyTypes ) {
						return propertyTypes[ id ];
					}

					return '';
				};

				var displayArrayAsCommaSpaceSeparatedValues = function displayArrayAsCommaSpaceSeparatedValues( arr ) {
					return arr.join( ', ' );
				};

				var displayPropertyTypes = function displayPropertyTypes( propertyTypesIdsStr ) {
					var propertyTypesIds = propertyTypesIdsStr.split( ',' );
					var propertyTypes = propertyTypesIds.map( getPropertyType );
					var propertyTypesStr = displayArrayAsCommaSpaceSeparatedValues( propertyTypes );
					return propertyTypesStr;
				};

				var displayStringAsCommaSpaceSeparatedValues = function displayStringAsCommaSpaceSeparatedValues( str ) {
					return str.replace( /,/g, ', ' );
				};

				var updateCurrentFilters = function updateCurrentFilters( data ) {
					var $container = $( '.search-and-filter-bar > .container-wide' );

					if ( $container.length === 0 ) {
						return;
					}

					var html = "<div class=\"search-and-filter-bar__current-filters\">\n      ".concat( typeof data[ 'sf_select_sp_openhouse' ] !== 'undefined' && data[ 'sf_select_sp_openhouse' ] == '1' ? '<div class="search-and-filter-bar__current-filter">Open House <a class="search-and-filter-bar__current-filter-reset-button" href="/properties/" data-reset-filter="sf_select_sp_openhouse">&times;</a></div>' : '', "\n      " ).concat( typeof data[ 'sf_textsearch_textsearch' ] !== 'undefined' && data[ 'sf_textsearch_textsearch' ] ? "<div class=\"search-and-filter-bar__current-filter search-and-filter-bar__current-filter--text-search\">".concat( data[ 'sf_textsearch_textsearch' ], " <a class=\"search-and-filter-bar__current-filter-reset-button\" data-reset-filter=\"sf_textsearch_textsearch\" href=\"/properties/\">&times;</a></div>" ) : '', "\n      " ).concat( typeof data[ 'sf_min_price' ] !== 'undefined' && data[ 'sf_min_price' ] !== '' || typeof data[ 'sf_max_price' ] !== 'undefined' && data[ 'sf_max_price' ] !== '' ? "<div class=\"search-and-filter-bar__current-filter\">Price: ".concat( typeof data[ 'sf_min_price' ] !== 'undefined' && data[ 'sf_min_price' ] !== '' ? formatPrice( +data[ 'sf_min_price' ] ) : '0K', "<span class=\"search-and-filter-bar__hyphen\">-</span>" ).concat( typeof data[ 'sf_max_price' ] !== 'undefined' && data[ 'sf_max_price' ] !== '' ? formatPrice( +data[ 'sf_max_price' ] ) : 'unlimited', " <a class=\"search-and-filter-bar__current-filter-reset-button\" href=\"/properties/\" data-reset-filter=\"sf_min_price,sf_max_price\">&times;</a></div>" ) : '', "\n      " ).concat(data['sf_tmin_bedrooms'] || data['sf_tmax_bedrooms'] ? "<div class=\"search-and-filter-bar__current-filter\">&nbsp;Beds: ".concat(data['sf_tmin_bedrooms' ] === data['sf_tmax_bedrooms'] ? data['sf_tmin_bedrooms'] : data['sf_tmin_bedrooms'] + (!data['sf_tmax_bedrooms'] ? '+' : ('-' + data['sf_tmax_bedrooms'])), " <a class=\"search-and-filter-bar__current-filter-reset-button\" href=\"/properties/\" data-reset-filter=\"sf_tmin_bedrooms,sf_tmax_bedrooms\">&times;</a></div>" ) : '', "\n      " ).concat( typeof data[ 'sf_tmin_bathrooms' ] !== 'undefined' && data[ 'sf_tmin_bathrooms' ] !== '' ? "<div class=\"search-and-filter-bar__current-filter\">Baths: ".concat( data[ 'sf_tmin_bathrooms' ] === '-1' ? 'Any' : data[ 'sf_tmin_bathrooms' ] + '+', " <a class=\"search-and-filter-bar__current-filter-reset-button\" href=\"/properties/\" data-reset-filter=\"sf_tmin_bathrooms\">&times;</a></div>" ) : '', "\n      " ).concat( typeof data[ 'sf_multiple_property_type' ] !== 'undefined' && data[ 'sf_multiple_property_type' ] !== '' ? "<div class=\"search-and-filter-bar__current-filter\">Property Types: ".concat( displayPropertyTypes( data[ 'sf_multiple_property_type' ] ), " <a class=\"search-and-filter-bar__current-filter-reset-button\" href=\"/properties/\" data-reset-filter=\"sf_multiple_property_type\">&times;</a></div>" ) : '', "\n      " ).concat( typeof data[ 'sf_multiple_feature' ] !== 'undefined' && data[ 'sf_multiple_feature' ] !== '' ? "<div class=\"search-and-filter-bar__current-filter\">Features: ".concat( displayStringAsCommaSpaceSeparatedValues( data[ 'sf_multiple_feature' ] ), " <a class=\"search-and-filter-bar__current-filter-reset-button\" href=\"/properties/\" data-reset-filter=\"sf_multiple_feature\">&times;</a></div>" ) : '', "\n      " ).concat( typeof data[ 'sf_multiple_field_3102' ] !== 'undefined' && data[ 'sf_multiple_field_3102' ] !== '' ? "<div class=\"search-and-filter-bar__current-filter\">Neighborhood: ".concat( displayStringAsCommaSpaceSeparatedValues( data[ 'sf_multiple_field_3102' ] ), " <a class=\"search-and-filter-bar__current-filter-reset-button\" href=\"/properties/\" data-reset-filter=\"sf_multiple_field_3102\">&times;</a></div>" ) : '', "\n      " ).concat( typeof data[ 'sf_text_field_3067' ] !== 'undefined' && data[ 'sf_text_field_3067' ] === '2874' ? '<div class="search-and-filter-bar__current-filter">AubreyGuri Only <a class="search-and-filter-bar__current-filter-reset-button" href="/properties/" data-reset-filter="sf_text_field_3067">&times;</a></div>' : '', "\n </div>" );

					var $currentFilters = $( '.search-and-filter-bar__current-filters' );

					var $savedFilter = '<div class="search-and-filter-bar__save-filter"><a class="search-and-filter-bar__save-filter-save-button" href="javascript:void(0)">SAVE THIS SEARCH</a></div>';

					if ( $currentFilters.length > 0 ) {
						$currentFilters.replaceWith( html );
					} else {
						$container.prepend( html );
					}

					var numItems = $( '.search-and-filter-bar__current-filter' ).length;

					if ( numItems > 0 ) {
						$( '.search-and-filter-bar__current-filters' ).append( $savedFilter );
					} else {
						$( '.search-and-filter-bar__save-filter' ).remove();
					}

					adjustSearchColumnWidth();
					adjustFilterColumnWidth();
					showOrHideSearchPlaceholder();
					showOrHideTextSearchFilter();
				};

				var showOrHideSearchPlaceholder = function showOrHideSearchPlaceholder() {
					var $searchInput = $( '.search-and-filter-bar__search-input' );
					$searchInput.attr( 'placeholder', 'Find available homes by keyword, MLS #, city, or zip code' );
					if ( $searchInput.width() < 364 ) {
						$searchInput.attr( 'placeholder', 'Find available homes by keyword' );
					} else {
						$searchInput.attr( 'placeholder', 'Find available homes by keyword, MLS #, city, or zip code' );
					}
				};

				var showTextSearchFilterOnDocumentReady = function showTextSearchFilterOnDocumentReady() {
					if ( /[?&]sf_textsearch_textsearch=+/.test( location.search ) ) {
						$( '.search-and-filter-bar' ).addClass( 'text-search-filter-is-visible' );
					}
				};

				var showOrHideTextSearchFilter = function showOrHideTextSearchFilter() {
					$( '.search-and-filter-bar__search-input' ).on( 'focus', function() {
						if ( $( '.search-and-filter-bar__current-filter--text-search' ).length > 0 ) {
							$( '.search-and-filter-bar' ).removeClass( 'text-search-filter-is-visible' );
						}
					} ).on( 'blur', function() {
						if ( $( '.search-and-filter-bar__current-filter--text-search' ).length > 0 ) {
							$( '.search-and-filter-bar' ).addClass( 'text-search-filter-is-visible' );
						}
					} );
				};

				var adjustSearchColumnWidth = function adjustSearchColumnWidth() {
					if ( $( '.search-and-filter-bar__current-filter' ).length > 0 && $( '.open-menu' ).is( ':visible' ) ) {
						$( '.search-and-filter-bar__search-col' ).removeClass( 'col-lg' );
					} else {
						$( '.search-and-filter-bar__search-col' ).addClass( 'col-lg' );
					}
				};

				var adjustFilterColumnWidth = function adjustFilterColumnWidth() {
					$( '.search-and-filter-bar__filter-col' ).addClass( 'col-lg-auto' ).removeClass( 'col-lg' );
					/*if ($('.search-and-filter-bar__current-filter').length > 0) {
					  $('.search-and-filter-bar__filter-col').addClass('col-lg').removeClass('col-lg-auto');
					} else {
					  $('.search-and-filter-bar__filter-col').addClass('col-lg-auto').removeClass('col-lg');
					}*/
				};

				var mobileToggleFiltersButtonClickHandler = function mobileToggleFiltersButtonClickHandler() {
					$( '.search-and-filter-bar__toggle-filters--mobile' ).on( 'click', function( e ) {
						e.preventDefault();
						var $this = $( this );

						if ( $this.is( '[aria-expanded="false"]' ) ) {
							$( '.search-and-filter-bar__filter-col' ).addClass( 'is-expanded' );
							$this.attr( 'aria-expanded', 'true' );
						} else {
							$( '.search-and-filter-bar__filter-col' ).removeClass( 'is-expanded' );
							$this.attr( 'aria-expanded', 'false' );
						}
					} );
				};

				var mobileToggleFilterClickHandler = function mobileToggleFilterClickHandler() {
					var timer;
					$( '.search-and-filter-form__filter-toggle, .search-and-filter-bar__filter-toggle' ).filter( '[aria-expanded="false"]' ).find( 'svg' ).replaceWith( '<span class="fa fa-chevron-right"></span>' );
					$( '.search-and-filter-form__filter-toggle, .search-and-filter-bar__filter-toggle' ).on( 'click', function() {
						var _this = this;

						clearTimeout( timer );
						timer = setTimeout( function() {
							var $this = $( _this );

							if ( $this.is( '[aria-expanded="true"]' ) ) {
								$this.find( 'svg' ).replaceWith( '<span class="fa fa-chevron-down"></span>' );
								$( '.search-and-filter-form__filter-toggle, .search-and-filter-bar__filter-toggle' ).filter( '[aria-expanded="false"]' ).find( 'svg' ).replaceWith( '<span class="fa fa-chevron-right"></span>' );
							} else {
								$this.find( 'svg' ).replaceWith( '<span class="fa fa-chevron-right"></span>' );
							}
						}, 500 );
					} );
				};

				var filterResetButtonClickHandler = function filterResetButtonClickHandler() {
					$( '.search-and-filter-bar__current-filter-reset-button' ).off().on( 'click', function( e ) {
						e.preventDefault();
						var resetFilter = $( this ).data( 'reset-filter' );

						if ( 'sf_multiple_field_3102' === resetFilter ) {
							$neighborhoodSelectBox.val( null ).trigger( "change" );
						} else {
							$( this ).data( 'reset-filter' ).split( ',' ).forEach( function( filter ) {
								var $field = $( "[name=\"".concat( filter, "\"]" ) );

								if ( $field.is( '[type="checkbox"]' ) || $field.is( '[type="radio"]' ) ) {
									$field.attr( 'checked', false );
								} else {
									$field.val( '' );
								}
							} );
						}

						if ( 'sf_multiple_feature' === resetFilter ) {
							$( '[aria-labelledby="featuresFilter"] [type="checkbox"]' ).attr( 'checked', false );
						}

						if ( 'sf_textsearch_textsearch' === resetFilter ) {
							$( '.search-and-filter-bar' ).removeClass('text-search-filter-is-visible');
						}

						getProperties();
						adjustSearchColumnWidth();
						adjustFilterColumnWidth();
					} );
				};

				var saveFilterButtonClickHandler = function saveFilterButtonClickHandler() {
					$( 'body' ).on( 'click', '.search-and-filter-bar__save-filter-save-button', function( e ) {
						e.preventDefault();
						var saveFilterForm = document.querySelector( '.save-filter-form' );
						var form = document.querySelector( '.search-and-filter-bar' );
						var filterFormData = new URLSearchParams( new FormData( form ) ).toString();
						var saveSearchTermData = [];
						var saveSearchTermDataIndex = 0;
						$(".search-and-filter-bar__current-filter").each(function (i, div) {
							saveSearchTermData[saveSearchTermDataIndex] = (div.textContent).replace(" ×", "");
							saveSearchTermDataIndex++;
						});

						if ( '0' === sage_loadmore_params.is_logged_in ) {
              document.querySelector( '.header__user-button--register' ).click();
              var registrationErrors = document.createElement('div');
              registrationErrors.classList.add('registration-errors');
              registrationErrors.innerHTML = '<p class="aubrey-form-success">Please log in or create an account to save your favorite searches.</p>';
              var registrationFormInstructions = document.querySelector('.registration-form__instructions');
              if (registrationFormInstructions !== null) {
                registrationFormInstructions.parentNode.insertBefore(registrationErrors, registrationFormInstructions.nextSibling);
              }
              
							document.querySelector( ".login-form__saved_search-value" ).value = filterFormData;
							document.querySelector( ".login--form__saved_search-term" ).value = saveSearchTermData.filter(Boolean).join("|");

							document.querySelector( ".registration-form__saved_search-value" ).value = filterFormData;
							document.querySelector( ".registration-form__saved_search-term" ).value = saveSearchTermData.filter(Boolean).join("|");
						} else {
							var overlay = document.querySelector( '.overlay' );

							document.querySelector( ".save-filter-form__search-value" ).value = filterFormData;
							document.querySelector( ".save-filter-form__input" ).value = saveSearchTermData.filter(Boolean).join("|");
							if ( overlay === null || saveFilterForm === null ) {
								return;
							}
							showLoadingLogo();
							$(".save-filter-form__submit-button").click();

							/*overlay.classList.add( 'is-active' );
							saveFilterForm.classList.add( 'is-active' );*/
						}

					} );
				};

				var handleSaveFilterFormCloseButtonClick = function handleSaveFilterFormCloseButtonClick() {
					var closeButton = document.querySelector( '.save-filter-form__close-button' );

					if ( closeButton === null ) {
						return;
					}

					closeButton.addEventListener( 'click', function() {
						var overlay = document.querySelector( '.overlay' );
						var saveFilterForm = document.querySelector( '.save-filter-form' );

						if ( overlay === null || saveFilterForm === null ) {
							return;
						}

						if ( overlay.classList.contains( 'is-active' ) ) {
							overlay.classList.remove( 'is-active' );
						}

						if ( saveFilterForm.classList.contains( 'is-active' ) ) {
							saveFilterForm.classList.remove( 'is-active' );
						}
					} );
				};

				var removeFilterFromAccountClickHandler = function removeFilterFromAccountClickHandler() {
					$( 'body' ).on( 'click', '.saved-searches-button__remove-button', function( e ) {
						e.preventDefault();
						var key = $( this ).data( 'remove-search' );
						var data = {
							action: 'aubreyguri_remove_search__filter_from_account',
							key: key,
						};
						$.ajax( {
							url: sage_loadmore_params.ajaxurl,
							data: data,
							type: 'POST',
							beforeSend: function( xhr ) {
								showLoadingLogo();
							},
							success: function( response ) {
								if ( response ) {
									location.reload();
								}
							}
						} );

					} );
				};

				var getNeighborhoodListFromDB = function getNeighborhoodListFromDB() {
					$neighborhoodSelectBox = $( ".search-and-filter-bar__neighborhood-select, .search-and-filter-form__neighborhood-select" ).select2( {
						placeholder: "Search a neighborhood",
						selectOnClose: false,
						closeOnSelect: true,
						minimumInputLength: 1,
						ajax: {
							dataType: "json",
							url: "/wp-content/themes/sage/lib/find-neighborhoods.php",
						},
						language: {
							noResults: function (params) {
								return "Sorry, no properties are currently listed for that neighborhood.";
							}
						}
					} );
				};

				var showLoadingLogo = function showLoadingLogo() {
					var $bodyContainer = $( 'body' );
					$bodyContainer.addClass( 'is-loading-logo-visible' );
				};

				var removeLoadingLogo = function removeLoadingLogo() {
					var $bodyContainer = $( 'body' );
					setTimeout(function(){
						$bodyContainer.removeClass( 'is-loading-logo-visible' );
					}, 700);
				};

				var showLoadingLogoInContent = function showLoadingLogoInContent() {
					var $mainContainer = $( '.wpl_property_listing_list_view_container' );
					$mainContainer.addClass( 'is-loading-logo-visible' );
				};

				var removeLoadingLogoFromContent = function removeLoadingLogoFromContent() {
					var $mainContainer = $( '.wpl_property_listing_list_view_container' );
					setTimeout(function(){
						$mainContainer.removeClass( 'is-loading-logo-visible' );
					}, 700);
				};

				var rememberPropertiesSearch = function rememberPropertiesSearch() {
					var pathname = location.pathname;
					var search = location.search;
					if (pathname && pathname.indexOf('/properties') === 0 && search) {
						sessionStorage.setItem('propertiesSearchUrl', pathname + search);
					}
				};

				var returnToPropertiesLinkClickHandler = function returnToPropertiesLinkClickHandler() {
					var link = document.querySelector('.return-to-properties-link');
					if (!link) {
						return;
					}

					link.addEventListener('click', function(event) {
						event.preventDefault();
						var propertiesSearchUrl = sessionStorage.getItem('propertiesSearchUrl');
						if (propertiesSearchUrl) {
							var container = document.querySelector('.wpl_prp_container');
							if (container) {
								var param = '&hash=' + container.id.replace('container', 'cont');
							}

							location.href = propertiesSearchUrl.split('&hash=')[0] + param;
						} else {
							location.href = link.href;
						}
					});
				};

				var scrollToPropertyIdOnLoad = function scrollToPropertyIdOnLoad() {
					if (!location.search) {
						return;
					}

					var hash = location.search.split('&hash=')[1];
					if (!hash) {
						return;
					}

					var $cont = $('#' + hash);
					var $scrollbar = $('.mCustomScrollbar');
					if ($cont.length > 0 && $scrollbar.length > 0) {
						$('html, body').animate({ scrollTop: $scrollbar.offset().top }, 400, 'swing', function() {
							$scrollbar.mCustomScrollbar("scrollTo", $scrollbar.offset().top - $cont.offset().top + 50);
						});
					}
				};

				var getProperties = function getProperties() {

					if ( !$( '.wpl_googlemap_container' ).hasClass( 'wpl-aps-addon' ) ) {
						showLoadingLogo();
						$( '.search-and-filter-bar' ).submit();
						return false;
					}

					var pageNum = arguments.length > 0 && arguments[ 0 ] !== undefined ? arguments[ 0 ] : 1;

					if ( xhrProperties ) {
						xhrProperties.abort();
					}

					var data = {
						action: 'get_properties',
						sf_ajaxpagenum_pagenum: pageNum
					};
					/*let searchString = window.location.search.slice(1);
					const pairsArr = searchString.split('&');
					pairsArr.forEach(pairStr => {
					  const pair = pairStr.split('=');
					  data[pair[0]] = pair[1];
					});*/

					showLoadingLogoInContent();
					$( '.search-and-filter-bar input[name], .aubreyguri-listings-only__checkbox, .search-and-filter-bar__filter-input--select' ).each( function() {
						var $input = $( this );

						if ( ($input.is( '[type="checkbox"]' ) || $input.is( '[type="radio"]' )) && !$input.is( ':checked' ) || $input.val() === '' ) {
							return true;
						}

						data[ $input.attr( 'name' ) ] = $input.val();
					} );
					updateCurrentFilters( data );

					delete data[ "sf_multiple_feature" ];
					filterResetButtonClickHandler();
					xhrProperties = $.get( '/wp-admin/admin-ajax.php', data ).done( function( results ) {
						wplListingContainer.mCustomScrollbar( "destroy" );
						$( '.wpl_property_listing_listings_container' ).remove();
						$( '<div/>', {
							"class": 'wpl-row wpl-expanded wpl-small-up-1 wpl-medium-up-2 wpl-large-up-3  wpl_property_listing_listings_container clearfix',
						} ).appendTo( '.wpl_property_listing_list_view_container' );
						$( '.wpl_property_listing_listings_container' ).html( results );
						delete data['action'];
						var newUrl = Object.keys(data || {}).reduce(function(url, key) {
							return url + '&' + key + '=' + data[key];
						}, '/properties/?sf_textsearch_textsearch=&sf_unit_price=260&sf_multiple_field_3102=&sf_multiple_feature=&sf_min_price=&sf_max_price=&sf_tmin_bedrooms=&sf_tmax_bedrooms=&sf_multiple_property_type=');
						history.pushState({}, '', newUrl);
						sessionStorage.setItem('propertiesSearchUrl', newUrl);
						ajaxPageNumberClickHandler();
						$( '.wpl_total_result' ).html( function() {
							var paginationAjax = $( '.pagination--ajax' ).data( 'total-result' );
							var checkAjaxPaginationResponse = paginationAjax ? paginationAjax : $('.wpl-column').length;
							var numResults = +checkAjaxPaginationResponse;
							var html = "".concat( isNaN( numResults ) ? 0 : numResults, " Result" ).concat( numResults > 1 ? 's' : '' );
							return html;
						} );

						initScrollbarForPropertyListings();

						swapBlackMarkerImagesWithWhiteImages();
						infoWindowDOMReadyHandler();
						removeLoadingLogoFromContent();
					} );
				};

				var getFilteredFavorites = function getFilteredFavorites() {
					var pageNum = arguments.length > 0 && arguments[ 0 ] !== undefined ? arguments[ 0 ] : 1;

					if ( xhrFilteredFavorites ) {
						xhrFilteredFavorites.abort();
					}

					var data = {
						action: 'get_filtered_favorites_html',
						sf_ajaxpagenum_pagenum: pageNum
					};
					/*let searchString = window.location.search.slice(1);
					const pairsArr = searchString.split('&');
					pairsArr.forEach(pairStr => {
					  const pair = pairStr.split('=');
					  data[pair[0]] = pair[1];
					});*/

					$( '.favorites .search-and-filter-form input[name]' ).each( function() {
						var $input = $( this );

						if ( ($input.is( '[type="checkbox"]' ) || $input.is( '[type="radio"]' )) && !$input.is( ':checked' ) || $input.val() === '' ) {
							return true;
						}

						data[ $input.attr( 'name' ) ] = $input.val();
          } );

          xhrFilteredFavorites = $.get( '/wp-admin/admin-ajax.php', data ).done( function( results ) {
            $( '.wpl-column, .wpl_pagination_container' ).remove();
						//$( '.container--favorites' ).html( results );
            $('.horizontal-properties-content-box').html(results);
            ajaxPageNumberClickHandler();
						$( '.wpl_total_result' ).html( function() {
							var paginationAjax = $( '.pagination--ajax' ).data( 'total-result' );
							var checkAjaxPaginationResponse = paginationAjax ? paginationAjax : $('.wpl-column').length;
							var numResults = +checkAjaxPaginationResponse;
							var html = "".concat( isNaN( numResults ) ? 0 : numResults, " Result" ).concat( numResults > 1 ? 's' : '' );
							return html;
						} );
						formatPropertyLocationText();
					} );
				};

				var clearFilters = function clearFilters() {
					if ( $( '.favorites' ).length === 0 ) {
						return;
					}

					$( '.favorites .search-and-filter-form input' ).each( function() {
						var $input = $( this );

						if ( $input.attr( 'type' ) === 'submit' ) {
							return true;
						}

						if ( $input.is( '[type="checkbox"]' ) || $input.is( '[type="radio"]' ) ) {
							$input.prop( 'checked', false );
							return true;
						}

						if ( $input.attr( 'name' ) === 'sf_unit_price' || $input.val() === '' ) {
							return true;
						}

						$input.val( '' );
					} );
				};

				var removeFavoriteClickHandler = function removeFavoriteClickHandler() {
					$('body').on('click', '.remove-favorite', function(e) {
						e.preventDefault();
						//var urlParams = new URLSearchParams( window.location.search );
						var wplpage = 1;// urlParams.get( 'wplpage' );
						//var pathname = window.location.pathname;
						/*if( '/favorites/' === pathname ) {
							showLoadingLogo();
							location.reload();
						}*/
						setTimeout( function() {
							$.get( '/wp-admin/admin-ajax.php', {
								action: 'get_favorites_html',
								page: wplpage || 1
							} ).done( function( data ) {
								$( '.horizontal-properties-content-box' ).html( data );
								formatPropertyLocationText();
							} );
						}, 2000 );
					} );
				};

				var maskPhoneInput = function maskPhoneInput() {
					$( 'input[name="phone"],#registration-form__phone' ).mask( '(999) 999-9999' );
				};

				var prefillContactListingMessage = function prefillContactListingMessage() {
					var location = $( '.wpl-location' ).text();
					/*$( '.wpl-contact-listing-msg > textarea' ).val( "I\u2019m interested in learning more about ".concat( location ) );*/
				};

				var sliderVisibilityChangeHandler = function sliderVisibilityChangeHandler() {
					var observer = new MutationObserver( function() {
						if ( $( '.bxslider' ).is( ':visible' ) ) {
							$( '#tabs-1' ).css( 'background-image', 'none' );
						} else {
							var blocksLoader = 'http://' + window.location.hostname.concat( '/wp-content/themes/sage/dist/images/blocks-loader.gif' );

							$( '#tabs-1' ).css( 'background-image', "url(\"".concat( blocksLoader, "\")" ) );
						}
					} );
					var target = document.querySelector( '.bx-viewport' );

					if ( target === null ) {
						return;
					}

					observer.observe( target, {
						attributes: true
					} );
				};

				var addSliderDirectionArrows = function addSliderDirectionArrows() {
					$( '.bx-prev' ).prepend( '<span class="icon-left"><img src="/wp-content/themes/sage/dist/images/bx-slider-prev-icon.png" /></span>' );
					$( '.bx-next' ).prepend( '<span class="icon-right"><img src="/wp-content/themes/sage/dist/images/bx-slider-next-icon.png" /></span>' );
				};

				var setTab1MinHeight = function setTab1MinHeight() {
					$( '#tabs-1' ).css( 'min-height', function() {
						return $( this ).width() * 0.6;
					} );
				};

				var replaceAgentContactSuccessMessage = function replaceAgentContactSuccessMessage() {
					$( '.wpl_contact_container > .wpl_green_msg' ).html( 'Thank you for your interest in this property. <br>An agent will be contacting you shortly.' ).css( 'opacity', 1 );
				};

				var swapBlackMarkerImagesWithWhiteImages = function swapBlackMarkerImagesWithWhiteImages() {
					$( '.wpl_map_canvas' ).imagesLoaded( function() {
						$( '.wpl-richmarker-icon > img' ).each( function() {
							$( this ).attr( 'src', function( i, oldSrc ) {
								var fileName = oldSrc.split( '/' ).pop();

								if ( fileName.indexOf( '-white' ) > -1 ) {
									return oldSrc;
								}

								var newFileName = fileName.replace( '.', '-white.' );

								var image = 'http://' + window.location.hostname.concat( '/wp-content/themes/sage/dist/images/property_types/', newFileName );

								return image;
							} );
						} );
					} );
				};

				var mapTabClickHandler = function mapTabClickHandler() {
					$( 'a[href="#tabs-2"]' ).on( 'click', function() {
						setTimeout( swapBlackMarkerImagesWithWhiteImages, 1000 );
					} );
				};

				var getDirectionsLinkClickHandler = function getDirectionsLinkClickHandler() {
					$( '.get-directions-link' ).on( 'click', function(e) {
						e.preventDefault();
						$( '.tabs_box > .tabs > li:last-child a' ).trigger('click');
					} );
				};

				var getSliderLinkClickHandler = function getSliderLinkClickHandler() {
					$( '.get-slider-link' ).on( 'click', function(e) {
						e.preventDefault();
						$( '.tabs_box > .tabs > li:first-child a' ).trigger('click');
					} );
				};

				var getDirectionsButtonClickHandler = function getDirectionsButtonClickHandler() {
					$( '.wpl-map-get-direction-btn-cnt' ).on( 'click', function() {
						if ( $( '.wpl-map-get-direction-address' ).val() !== '' ) {
							$( '.close-directions-link' ).removeClass( 'd-none' );
						}
					} );
				};

				var closeDirectionsLinkClickHandler = function closeDirectionsLinkClickHandler() {
					$( '.close-directions-link, .wpl-map-get-direction-reset' ).on( 'click', function( e ) {
						e.preventDefault();

						if ( $( this ).is( '.close-directions-link' ) ) {
							window.wpl_remove_direction15();
						}

						$( '.close-directions-link' ).addClass( 'd-none' );

						$('html, body').animate({scrollTop:0}, '300');

					} );
				};

				var addOpenHouseDatePickers = function addOpenHouseDatePickers() {
					var urlParams = new URLSearchParams( window.location.search );

					if ( window.location.pathname.indexOf( '/properties' ) !== 0 || !urlParams.has( 'sf_select_sp_openhouse' ) || urlParams.get( 'sf_select_sp_openhouse' ) !== '1' || $( '.open-house-date-pickers' ).length > 0 ) {
						return;
					}

					var calendarIcon = 'http://' + window.location.hostname.concat( '/wp-content/themes/sage/dist/images/calendar-icon.png' );

					var html = "<div class=\"open-house-date-pickers\">\n      <div class=\"open-house-date-pickers__label\">Search Open Houses by Date</div>\n      <div class=\"open-house-date-pickers__picker-wrapper\">\n        <input type=\"text\" class=\"open-house-date-pickers__picker open-house-date-pickers__picker--min-date\" placeholder=\"mm/dd/yy\">\n        <img class=\"open-house-date-pickers__picker-icon\" src=\"".concat( calendarIcon, "\">\n      </div>\n      <span class=\"open-house-date-pickers__separator\">to</span>\n      <div class=\"open-house-date-pickers__picker-wrapper\">\n        <input type=\"text\" class=\"open-house-date-pickers__picker open-house-date-pickers__picker--max-date\" placeholder=\"mm/dd/yy\">\n        <img class=\"open-house-date-pickers__picker-icon\" src=\"" ).concat( calendarIcon, "\">\n      </div>\n    </div>" ); //$('.page-header').after(html);

					$( '.wpl_property_listing_listings_container' ).prepend( html );
				};

				var initOpenHouseDatePickers = function initOpenHouseDatePickers() {
					$( '.open-house-date-pickers__picker--min-date' ).datepicker( {
						dateFormat: 'mm/dd/y'
					} );
					$( '.open-house-date-pickers__picker--max-date' ).datepicker( {
						dateFormat: 'mm/dd/y'
					} );
				};

				var datePickerChangeHandler = function datePickerChangeHandler() {
					$( '.open-house-date-pickers__picker' ).on( 'change', function() {
						getPropertiesByOpenDates();
					} );
				};

				var ajaxPageNumberClickHandler = function ajaxPageNumberClickHandler() {
					$( '.pagination--ajax a' ).off().on( 'click', function( e ) {
						e.preventDefault();
						var pageNum = $( this ).data( 'page-number' ) || 1;

						if ( $( '.open-house-date-pickers' ).length > 0 ) {
							return getPropertiesByOpenDates( pageNum );
						}

						if ( $( '.favorites' ).length > 0 ) {
							return getFilteredFavorites( pageNum );
						}

						getProperties( pageNum );
					} );
				};

				var getPropertiesByOpenDates = function getPropertiesByOpenDates() {
					var pageNum = arguments.length > 0 && arguments[ 0 ] !== undefined ? arguments[ 0 ] : 1;

					if ( xhrPropertiesByOpenDates ) {
						xhrPropertiesByOpenDates.abort();
					}

					var minDate = $( '.open-house-date-pickers__picker--min-date' ).val();
					var maxDate = $( '.open-house-date-pickers__picker--max-date' ).val();

					if ( !minDate || !maxDate ) {
						return;
					}

					var data = {
						action: 'get_properties_by_opendates',
						sf_opendatemin_opendate: minDate,
						sf_opendatemax_opendate: maxDate,
						sf_ajaxpagenum_pagenum: pageNum
					};
					var searchString = window.location.search.slice( 1 );
					var pairsArr = searchString.split( '&' );
					pairsArr.forEach( function( pairStr ) {
						var pair = pairStr.split( '=' );
						data[ pair[ 0 ] ] = pair[ 1 ];
					} );
					xhrPropertiesByOpenDates = $.get( '/wp-admin/admin-ajax.php', data ).done( function( results ) {
						wplListingContainer.mCustomScrollbar( "destroy" );
						$( '.wpl_property_listing_listings_container .wpl-column, .wpl_pagination_container, .no-results-message, .section-title, .hot-searches-buttons' ).remove();
						$( '.open-house-date-pickers' ).after( results );
						changeNoResultsMessageForOpenHouse();
						ajaxPageNumberClickHandler();
						$( '.wpl_total_result' ).html( function() {
							var paginationAjax = $( '.pagination--ajax' ).data( 'total-result' );
							var checkAjaxPaginationResponse = paginationAjax ? paginationAjax : $('.wpl-column').length;
							var numResults = +checkAjaxPaginationResponse;
							var html = "".concat( isNaN( numResults ) ? 0 : numResults, " Result" ).concat( numResults > 1 ? 's' : '' );
							return html;
						} );

						initScrollbarForPropertyListings();

						swapBlackMarkerImagesWithWhiteImages();
						infoWindowDOMReadyHandler();
					} );
				};

				var changeNoResultsMessageForOpenHouse = function changeNoResultsMessageForOpenHouse() {
					if ( $( '[data-reset-filter="sf_select_sp_openhouse"]' ).length > 0 ) {
						$( '.no-results-message' ).html( 'THERE ARE CURRENTLY NO OPEN HOUSES SCHEDULED.' );
					}
				};

				var propertyDetailsAccordionButtonClickHandler = function propertyDetailsAccordionButtonClickHandler() {
					var timer = null;
					$( '.property-details-accordion-button' ).off( 'click' ).on( 'click', function() {
						clearTimeout( timer );
						timer = setTimeout( function() {
							$( '.property-details-accordion-button[aria-expanded="false"]' ).find( 'svg' ).replaceWith( '<span class="fa fa-chevron-right"></span>' );
							$( '.property-details-accordion-button[aria-expanded="true"]' ).find( 'svg' ).replaceWith( '<span class="fa fa-chevron-down"></span>' );
						}, 700 );
					} );
				};

				var addGalleryLightbox = function addGalleryLightbox() {
					if ( $( '.wpl_property_show' ).length === 0 ) {
						return;
					}

          var html = '';
					$( '.wpl-slider-bx-pager-wp img' ).each( function() {
						var $this = $( this );
						var thumbSrc = $this.attr( 'data-src' );
						var largeSrc = thumbSrc.replace( /th([^/.]+)_[^.]+/, '$1' );
						var alt = $this.attr( 'alt' );
						html += "<a class=\"chocolat-image\" href=\"".concat( largeSrc, "\" title=\"" ).concat( alt, "\"><img src=\"" ).concat( thumbSrc, "\"></a>" );
					} );
					$( '<div class="gallery-lightbox" />' ).html( html ).appendTo( '.wpl_property_show' );
				};

				var initGalleryLightbox = function initGalleryLightbox() {
					//$.fn.Chocolat = _chocolat.default;
					lightBox = $( '.gallery-lightbox' ).Chocolat().data( 'chocolat' );
					$( '.gallery-lightbox' ).hide();
				};

				var adjustThumbnailsVisibilityAndLightboxHeight = function adjustThumbnailsVisibilityAndLightboxHeight() {
					if ( $( '.open-menu' ).is( ':visible' ) || $( '.chocolat-wrapper' ).length === 0 || $( '.chocolat-wrapper' ).is( ':hidden' ) ) {
						$( '.gallery-lightbox' ).fadeOut();
						$( '.chocolat-wrapper' ).height( '100%' );
					} else {
						$( '.gallery-lightbox' ).fadeIn();
						$( '.chocolat-wrapper' ).height( function() {
							return $( window ).height() - $( '.gallery-lightbox' ).height();
						} );
					}
				};

				var openLightboxLinkClickHandler = function openLightboxLinkClickHandler() {
					$( '.open-lightbox-link' ).on( 'click', function( e ) {
						e.preventDefault();

						if ( lightBox === null ) {
							return;
						}

						lightBox.api().open();
						adjustThumbnailsVisibilityAndLightboxHeight();
						chocolatCloseClickHandler();
					} );
				};

				var chocolatCloseClickHandler = function chocolatCloseClickHandler() {
					var hideThumbnails = function hideThumbnails() {
						$( '.gallery-lightbox' ).fadeOut();
					};

					$( '.chocolat-overlay' ).not( '.chocolat-content' ).add( '.chocolat-close' ).off( 'click', hideThumbnails ).on( 'click', hideThumbnails );
				};

				var addFeaturesMultipleValuesToHiddenField = function addFeaturesMultipleValuesToHiddenField() {
					$( '.search-and-filter-form__feature-checkbox, .search-and-filter-bar__feature-checkbox' ).on( 'change', function() {
						var featureLists = $( '.search-and-filter-form__feature-checkbox:checked, .search-and-filter-bar__feature-checkbox:checked' ).map( function() {
							featureList = $( this ).data( 'value' );

							return featureList;
						} ).get().join( ',' );
						$( '.search-and-filter-form__features, .search-and-filter-bar__features' ).val( featureLists ).trigger( 'change' );
					} );
				};

				var addNeighborhoodMultipleValuesToHiddenField = function addNeighborhoodMultipleValuesToHiddenField() {
					/*$( '.search-and-filter-form__neighborhood-checkbox, .search-and-filter-bar__neighborhood-checkbox' ).on( 'change', function() {
						var neighborhoodDistricts = $( '.search-and-filter-form__neighborhood-checkbox:checked, .search-and-filter-bar__neighborhood-checkbox:checked' ).map( function() {
							neighborhoodDistrict = $( this ).data( 'value' );

							return neighborhoodDistrict;
						} ).get().join( ',' );
						$( '.search-and-filter-form__neighborhoods, .search-and-filter-bar__neighborhoods' ).val( neighborhoodDistricts ).trigger( 'change' );
					} );*/

					$neighborhoodSelectBox.on( "change", function( e ) {
						var selected = [];
						if ( $( this ).select2( 'data' ).length ) {
							$.each( $( this ).select2( 'data' ), function( key, item ) {
								selected.push( item.text );
							} );
							var neighborhoodDistricts = selected.join( ',' );
							$( '.search-and-filter-form__neighborhoods, .search-and-filter-bar__neighborhoods' ).val( neighborhoodDistricts ).trigger( 'change' );
						} else {
							$( '.search-and-filter-form__neighborhoods, .search-and-filter-bar__neighborhoods' ).val( '' ).trigger( 'change' );
						}
						if ( $( '#neighborhoodFilter' ).attr( 'aria-expanded' ) === "true" ) {
							$( '#neighborhoodFilter' ).click();
						}
					} );
				};

				var verticalSlidesFade = function verticalSlidesFade() {
					$( '.vertical-slider-inner' ).on( 'beforeChange', function( event, slick, currentSlide ) {
            if (event.target.classList.contains('testimonial-slider')) {
              return;
            }

						hvs.destroy();
						ivs.destroy();
						revealHomeVerticalSliderItems();
						revealInnerVerticalSliderItems();
					} );

					$( '.vertical-slider-inner' ).on( 'afterChange', function( event, slick, currentSlide ) {
						if ( slick.$slider.hasClass( 'testimonial-slider' ) || slick.$slider.attr('id') === 'sbi_images' || slick.$slider.hasClass('instagram-slides' ) || slick.$slider.hasClass( 'cff-default-styles' ) || slick.$slider.hasClass( 'tweet-slides' ) ) {
							return;
						}

						$( '.flip-panel-dots > li' ).removeClass( 'flip-active' )
							.filter( '[data-id="' + (currentSlide + 1) + '"]' )
							.addClass( 'flip-active' );
					} );

					$( document ).on( "click", '.panel-flip', function( e ) {
						e.preventDefault();
						$( this ).closest( '.home-vertical-slider-nav, .inner-page-vertical-slider-nav' ).prev( '.vertical-slider-inner.slick-initialized' ).slick( 'slickNext' );
					} );

					$( document ).on( "click", '.flip-panel-dots button', function() {
						$( this ).closest( '.home-vertical-slider, .inner-page-vertical-slider' ).find( '.vertical-slider-inner.slick-initialized' ).slick( 'slickGoTo', +$( this ).parent().data( 'id' ) - 1 );
					} );
				};

				var verticalSlidesFlip = function verticalSlidesFlip() {

					var $homeVerticalSlider = $( '.home-vertical-slider' );
					var homeCurPage = 1;
					var homeNumOfPages = $homeVerticalSlider.find( '.home-vertical-slider__slide' ).length;
					var animTime = 1000;
					var scrolling = false;
					var homePGPrefix = ".home-vertical-slider__slide--";

					function homePagination() {
						scrolling = true;
						$( '.home-vertical-slider__slide' ).removeClass( 'home-vertical-slider__slide-active-z-index' );
						$( homePGPrefix + homeCurPage ).removeClass( "home-vertical-slider__slide-inactive" ).addClass( "home-vertical-slider__slide-active" );
						$( homePGPrefix + (homeCurPage - 1) ).addClass( "home-vertical-slider__slide-inactive" );
						$( homePGPrefix + (homeCurPage + 1) ).removeClass( "home-vertical-slider__slide-active" );

						var flipPanelDots = $( '.flip-panel-dots' );
						flipPanelDots.find( 'li' ).removeClass( 'flip-active' );
						flipPanelDots.find( '[data-id="' + homeCurPage + '"]' ).addClass( 'flip-active' );

						if ( homeCurPage === homeNumOfPages ) {
							$( '.panel-flip' ).addClass( 'disabled' );
						} else {
							$( '.panel-flip' ).removeClass( 'disabled' );
						}

						setTimeout( function() {
							scrolling = false;
							$( homePGPrefix + homeCurPage ).addClass( 'home-vertical-slider__slide-active-z-index' );
						}, animTime );
					}

					function homeNavigateUp() {
						if ( homeCurPage === 1 ) {
							return;
						}
						homeCurPage--;
						homePagination();
					}

					function homeNavigateDown() {
						if ( homeCurPage === homeNumOfPages ) {
							return;
						}

						homeCurPage++;
						homePagination();
					}

					$( document ).on( "click", '.home-vertical-slider-nav .panel-flip', function( e ) {
						if ( scrolling ) {
							return;
						}
						homeNavigateDown();
					} );

					$( document ).on( "click", '.home-vertical-slider .flip-panel-dots li', function( e ) {
						var flipPanelDots = $( '.flip-panel-dots' );
						targetID = $( this ).data( 'id' );
						homeCurPage = targetID;

						flipPanelDots.find( 'li' ).removeClass( 'flip-active' );
						$( this ).addClass( 'flip-active' );

						homePagination();
					} );

					var $innerVerticalSlider = $( '.inner-page-vertical-slider' );
					var innerCurPage = 1;
					var innerNumOfPages = $innerVerticalSlider.find( '.inner-page-vertical-slider__slide' ).length;
					var innerPGPrefix = ".inner-page-vertical-slider__slide--";

					function innerPagePagination() {
						scrolling = true;
						$( '.inner-page-vertical-slider__slide' ).removeClass( 'inner-page-vertical-slider__slide-active-z-index' );
						$( innerPGPrefix + innerCurPage ).removeClass( "inner-page-vertical-slider__slide-inactive" ).addClass( "inner-page-vertical-slider__slide-active" );
						$( innerPGPrefix + (innerCurPage - 1) ).addClass( "inner-page-vertical-slider__slide-inactive" );
						$( innerPGPrefix + (innerCurPage + 1) ).removeClass( "inner-page-vertical-slider__slide-active" );

						var flipPanelDots = $( '.flip-panel-dots' );
						flipPanelDots.find( 'li' ).removeClass( 'flip-active' );
						flipPanelDots.find( '[data-id="' + innerCurPage + '"]' ).addClass( 'flip-active' );

						if ( innerCurPage === innerNumOfPages ) {
							$( '.panel-flip' ).addClass( 'disabled' );
						} else {
							$( '.panel-flip' ).removeClass( 'disabled' );
						}

						setTimeout( function() {
							scrolling = false;
							$( innerPGPrefix + innerCurPage ).addClass( 'inner-page-vertical-slider__slide-active-z-index' );
						}, animTime );
					}

					function innerPageNavigateUp() {
						if ( innerCurPage === 1 ) {
							return;
						}
						innerCurPage--;
						innerPagePagination();
					}

					function innerPageNavigateDown() {
						if ( innerCurPage === innerNumOfPages ) {
							return;
						}
						innerCurPage++;
						innerPagePagination();
					}

					$( document ).on( "click", '.inner-page-vertical-slider-nav .panel-flip', function( e ) {
						if ( scrolling ) {
							return;
						}
						innerPageNavigateDown();
					} );

					$( document ).on( "click", '.inner-page-vertical-slider .flip-panel-dots li', function( e ) {
						var flipPanelDots = $( '.flip-panel-dots' );
						targetID = $( this ).data( 'id' );
						innerCurPage = targetID;

						flipPanelDots.find( 'li' ).removeClass( 'flip-active' );
						$( this ).addClass( 'flip-active' );

						innerPagePagination();
					} );
				};

				var newsletterClickHandler = function newsletterClickHandler() {
					$( 'body' ).on( 'click', '.aubreyguri-newsletter-action', function( e ) {
						e.preventDefault();
						var channel = $( this ).data( 'channel' );
						if ( 'not-logged-in' === channel ) {
							document.querySelector( '.header__user-button--register' ).click();
							document.getElementById( "registration-form__newsletter" ).checked = true;
						} else {
							var option = $( this ).data( 'action' );
							var data = {
								action: 'aubreyguri_newsletter_confirmation',
								selection: option,
							};
							$.ajax( {
								url: sage_loadmore_params.ajaxurl,
								data: data,
								type: 'POST',
								beforeSend: function( xhr ) {
									showLoadingLogo();
								},
								success: function( response ) {
									if ( response ) {
										location.reload();
									}
								}
							} );
						}

					} );
				};

				var toggleFiltersClickHandler = function toggleFiltersClickHandler() {
					$( '.toggle-search-filters' ).on( 'click', function() {
						var $this = $( this );

						if ( $this.attr( 'aria-expanded' ) === 'false' ) {
							$( '.search-and-filter-form__filters' ).slideDown();
							$this.attr( 'aria-expanded', 'true' );
						} else {
							$( '.search-and-filter-form__filters' ).slideUp();
							$this.attr( 'aria-expanded', 'false' );
						}
					} );
				};

				var contactFormMailSentHandler = function contactFormMailSentHandler() {
					var wpcf7Elm = document.querySelector( '.wpcf7' );

					if ( wpcf7Elm === null ) {
						return;
					}

					wpcf7Elm.addEventListener( 'wpcf7mailsent', function() {
						$( 'html, body' ).animate( { scrollTop: $( '.wpcf7-response-output' ).offset().top }, 'slow' );
					} );
				};

				var initMainTwitterSlider = function initMainTwitterSlider() {
					$( '.tweet-slides' ).slick( {
						autoplay: false,
						autoplaySpeed: 5000,
						fade: true,
						appendArrows: '.twitter-posts',
						prevArrow: '.twitter__slider-nav-button--prev',
						nextArrow: '.twitter__slider-nav-button--next',
						adaptiveHeight: true,
					} );
				};

				var initMainFacebookSlider = function initMainFacebookSlider() {
					$( '#cff' ).slick( {
						autoplay: false,
						adaptiveHeight: true,
						autoplaySpeed: 5000,
						fade: true,
						appendArrows: '.facebook-posts',
						prevArrow: '.facebook__slider-nav-button--prev',
						nextArrow: '.facebook__slider-nav-button--next'
					} );
				};

				var initMainInstagramSlider = function initMainInstagramSlider() {
					//var instagramimage = $( '.instagram-post:first-child' ).data( 'image' );
					//$( '.home-vertical-slider__slide--2>.home-vertical-slider__col--1' ).css( "background-image", "url(" + instagramimage + ")" );
					$( '.instagram-slides, #sbi_images' ).slick( {
						autoplay: false,
						autoplaySpeed: 5000,
						fade: true,
						//appendArrows: '.instagram-posts',
						prevArrow: '.instagram__slider-nav-button--prev',
						nextArrow: '.instagram__slider-nav-button--next'
					} );
					/*$( '.instagram-slides, #sbi_images' ).on( 'afterChange', function( event, slick, currentSlide ) {
						var CurrentSlideDom = $( slick.$slides.get( currentSlide ) );
						instagramimage = CurrentSlideDom.find( '.instagram-post' ).data( 'image' );
						$( '.home-vertical-slider__slide--2>.home-vertical-slider__col--1' ).css( "background-image", "url(" + instagramimage + ")" );
					} );*/
				};

				var initMortgageCalculator = function initMortgageCalculator() {
					var inputLabel = $( '.lidd_mc_input_responsive label' );
					var inputField = $( '.lidd_mc_input_responsive input[type="text"]' );

					inputField.val( '' );

					inputLabel.click( function() {
						$( this ).parent().find( 'input' ).focus();
					} );

					inputField.focus( function() {
						$( this ).parent().find( 'label' ).addClass( 'move-placeholder-at-top' );
					} );

					inputField.blur( function() {
						var $this = $( this );
						if ( $this.val().length == 0 ) {
							$( this ).parent().find( 'label' ).removeClass( 'move-placeholder-at-top' );
						}
					} );

					inputField.blur();

					$( '#lidd_mc_total_amount,#lidd_mc_down_payment' ).attr( 'placeholder', '$ Amount' ).attr( 'type', 'number' );
					$( '#lidd_mc_interest_rate' ).attr( 'placeholder', '% Amount' ).attr( 'type', 'number' );
					$( '#lidd_mc_amortization_period' ).attr( 'placeholder', 'in Years' ).attr( 'type', 'number' );

					$( '#lidd_mc_total_amount' ).addClass( 'validate[required,custom[integer],min[1],max[99999999]]' );
					$( '#lidd_mc_down_payment' ).addClass( 'validate[min[0],custom[checkEnterTotalAmount]]' );

					$( '#lidd_mc_interest_rate' ).addClass( 'validate[required,custom[integer],min[1],max[30]]' );
					$( '#lidd_mc_amortization_period' ).addClass( 'validate[required,custom[integer],min[1],max[50]]' );
				};

				var initAubreyguriPreloader = function initAubreyguriPreloader() {
          var imgLoad = imagesLoaded('.main');
          var count = 0;
          imgLoad.on('progress', function(instance, image) {
            if (image.isLoaded) {
              count++;
            }

            if (count === 6) {
              document.querySelector('body').classList.add('loaded');
            }
          });
          
          imgLoad.on('always', function() {
            document.querySelector('body').classList.add('loaded');
					});
        };
        
        var handleGlobalSignupFormControlEvents = function handleGlobalSignupFormControlEvents() {
          $('.global-signup-form').find('input[type="text"], input[type="email"]').each(function (index, element) {
            if (element.value !== '') {
              $(element).closest('.form-group').find('label').addClass('move-placeholder-at-top');
            }
          })
          $('.global-signup-form').on('focus', 'input[type="text"], input[type="email"]', function(e) {
            $(e.target).closest('.form-group').find('label').addClass('move-placeholder-at-top');
          }).on('blur', 'input[type="text"], input[type="email"]', function(e) {
            if (e.target.value === '') {
              $(e.target).closest('.form-group').find('label').removeClass('move-placeholder-at-top');
            }
          }).on('click', 'label', function(e) {
            $(e.target).closest('.form-group').find('input[type="text"], input[type="email"]').focus();
          });
        };
        
        var displayCovidMessagePopup = function displayCovidMessagePopup() {
          if (location.pathname === '/' && sessionStorage.getItem('visited') !== '1') {
          $( '<style>@media (max-width: 500px) { .covid-message-popup { width: calc(100% - 30px) !important; padding: 30px 15px 15px !important; } .covid-message-popup__close-button { right: 0 !important; top: -60px !important; } }</style>' ).appendTo( "head" );
            var html = '<div class="white-overlay" style="position: absolute; left: 0; top: 0; right: 0; bottom: 0; z-index: 100000; background: rgba(255, 255, 255, 0.95);"></div><div class="covid-message-popup" style="position: absolute; left: 50%; top: 100px; z-index: 100001; -webkit-transform: translate(-50%, 0); -ms-transform: translate(-50%, 0); transform: translate(-50%, 0); width: calc(100% - 200px); max-width: 900px; padding: 70px; border: 1px solid #999; box-sizing: border-box; background: #fff; color: #333;"><button class="covid-message-popup__close-button" style="position: absolute; right: -80px; top: 0; width: 40px; height: 40px; padding: 0; border: 1px solid #999; border-radius: 50%; background: #fff; font-size: 24px; line-height: 38px; cursor: pointer;" type="button">×</button><img src="' + baseUrl + '/wp-content/themes/sage/dist/images/AubreyGuri-Logo.svg" style="width: 200px; max-width: 100%; margin-bottom: 30px;" alt="IDX Image"><p style="margin-bottom: 30px;">As the COVID-19 situation evolves, the Aubrey Guri Team will now be offering virtual showings as a way to practice social distancing. It’s our responsibility to help keep our community that we love and support safe. We’re grateful for the technology that allows us to safely help our clients from the comfort of their own home. We will still be offering in-person showings for those are comfortable viewing properties in-person. If you have any questions or concerns, please contact us at <a href="mailto:inquire@aubreyguri.com"><strong>inquire@aubreyguri.com</strong></a>.</p><p style="margin-bottom: 30px;">For more information, please follow us @aubreyguriteam on social media.</p><div class="covid-message-popup__social-buttons" style="display: inline-flex; flex-wrap: wrap; padding: 15px 15px 0px; background: rgb(34, 34, 34); opacity: 1; transition: all 0.4s ease 0s;"><a href="https://www.facebook.com/AubreyGuriTeam/" target="_blank" rel="noopener noreferrer" style="margin-right: 15px;"><img src="' + baseUrl + '/wp-content/uploads/2020/06/facebook-footer.png" alt="IDX Image"></a><a href="https://twitter.com/AubreyGuriteam" target="_blank" rel="noopener noreferrer" style="margin-right: 15px; margin-bottom: 15px;"><img src="' + baseUrl + '/wp-content/uploads/2020/06/twitter-footer.png" alt="IDX Image"></a><a href="https://www.instagram.com/aubreyguriteam/" target="_blank" rel="noopener noreferrer" style="margin-right: 15px; margin-bottom: 15px;"><img src="' + baseUrl + '/wp-content/uploads/2020/06/insta-footer.png" alt="IDX Image"></a><a href="https://www.youtube.com/channel/UCSEoURTQal2MU_8XlwAa_NA" target="_blank" rel="noopener noreferrer" style="margin-right: 15px; margin-bottom: 15px;"><img src="' + baseUrl + '/wp-content/uploads/2020/06/youtube-footer.png" alt="IDX Image"></a><a href="https://www.linkedin.com/company/aubreyguriteam/" target="_blank" rel="noopener noreferrer" style="margin-right: 15px; margin-bottom: 15px;"><img src="' + baseUrl + '/wp-content/uploads/2020/06/linkedin-footer.png" alt="IDX Image"></a><a href="https://www.pinterest.com/aubreyguriteam/" target="_blank" rel="noopener noreferrer" style="margin-bottom: 15px;"><img src="' + baseUrl + '/wp-content/uploads/2020/06/pinterest-footer.png" alt="IDX Image"></a></div></div>';
            $('body').append(html);
            $(".covid-message-popup__close-button").on("click", function() {
              $(".covid-message-popup, .white-overlay").fadeOut();
            });

            $(".covid-message-popup__social-buttons img").load(function() {
              $(".covid-message-popup__social-buttons").css("opacity", 1);
            });

            sessionStorage.setItem('visited', '1');
          }
				};
				
				var openAdvancedSearchOnLoad = function openAdvancedSearchOnLoad() {
					var hash = location.hash;
					if (hash && hash === '#advanced-search') {
						var $search = $('.search');
						if ($search.length === 0) {
							return;
						}

						$('html, body').animate({ scrollTop: $search.offset().top - 50 }, 400, 'swing', function() {
							$('.toggle-search-filters[aria-expanded="false"]').trigger('click');
						});
					}
				};

        initAubreyguriPreloader();
        initAnimationinit();
				scroll_to_top_button_handler();
				move_account_portal_placeholder_top();
				setMinMaxPriceSelect();
				toggleMobileMenu();
        toggleDropdownMenu();
				toggleDropdown();
				addHotSearchesMenu();
				formatPropertyLocationText();
				handleLoginButtonClick();
				handleLoginFormCloseButtonClick();
				handleRegisterButtonClick();
				handleRegistrationFormCloseButtonClick();
				handleForgetPasswordFormCloseButtonClick();
				handleVideoEmbedButtonClick();
				handleVideoEmbedCloseButtonClick();
				handleResetPasswordFormCloseButtonClick();
				handleFavoriteButtonClick();
				load_more_posts();
				//setScrollbarForVerticalSlider();
				verticalSlidesFade();
				//verticalSlidesFlip();
				setPlaceholderAtTop();

				closeDropdownOnBackgroundClick();

				addPhotosCount();
				fadeInPropertiesOnImagesLoaded();
				changePropertyListingPageHeader();
				propertyDetailsAccordionButtonClickHandler();
				addBedroomsMultipleValuesToHiddenField();
				addPropertyTypesMultipleValuesToHiddenField();
				initScrollbarForPropertyListings();
				setMapCanvasHeight();
				//addIconsToPagination();
				accountFormLinkClickHandler();
				modifyAndMoveTotalResult();
        addNoResultsHtml();
        handleGlobalSignupFormControlEvents();
				/*addAgentEmail();
				addViewProfileLink();
				switchToLargeAgentImageAndMoveImage();

				registerButtonLinkClickHandler();
				forgotPasswordLinkClickHandler();
				closeButtonClickHandler();
				addMiuccioListingsOnlyFilter();*/
				searchAndFilterBarTextInputHandler();
        searchAndFilterBarInputChangeHandler();
        searchAndFilterBarSearchButtonClickHandler();
				searchAndFilterFavoritesTextInputHandler();
				searchAndFilterFavoritesInputChangeHandler();
				searchAndFilterFavoritesSearchButtonClickHandler();
				rememberPropertiesSearch();
				returnToPropertiesLinkClickHandler();
				clearFilters();
				saveFilterButtonClickHandler();
				formatPropertyLocationText();
				removeFavoriteClickHandler();
				maskPhoneInput();
				prefillContactListingMessage();
				setTab1MinHeight();
				/*addAgentContactInfoToAgentsList();
				addHTMLToAgentProfile();*/
				addOpenHouseDatePickers();
				initOpenHouseDatePickers();
				datePickerChangeHandler();
				changeNoResultsMessageForOpenHouse();
				contactFormMailSentHandler();
				/*addAgentsMenu();*/
				showTextSearchFilterOnDocumentReady();
				newsletterClickHandler();
				handleSaveFilterFormCloseButtonClick();
				removeFilterFromAccountClickHandler();
				activateOrDeactivateVerticalSlider();
				getNeighborhoodListFromDB();
				addNeighborhoodMultipleValuesToHiddenField();
				addFeaturesMultipleValuesToHiddenField();
				filterResetButtonClickHandler();
				toggleFiltersClickHandler();
				initMainTwitterSlider();
				initMainFacebookSlider();
				initMainInstagramSlider();
        initMortgageCalculator();
				displayCovidMessagePopup();
        //initPropertyValueCalculator();
        //toggleCheckboxesDropdown();

				$( window ).on( 'load', function() {
					showOrHideSearchPlaceholder();
					showOrHideTextSearchFilter();
					mobileToggleFiltersButtonClickHandler();
					mobileToggleFilterClickHandler();
					sliderVisibilityChangeHandler();
					addSliderDirectionArrows();
					swapBlackMarkerImagesWithWhiteImages();
					mapTabClickHandler();
					getDirectionsLinkClickHandler();
					getSliderLinkClickHandler();
					getDirectionsButtonClickHandler();
					closeDirectionsLinkClickHandler();
					addGalleryLightbox();
					initGalleryLightbox();
					openLightboxLinkClickHandler();
					removeLoadingLogoFromContent();
          setScrollbarForVerticalSlider();
					openAdvancedSearchOnLoad();
					scrollToPropertyIdOnLoad();
          //initMortgageCalculator(); 
          //initPropertyValueCalculator();
				} );
				$( window ).on( 'ajaxSuccess', function() {
					infoWindowDOMReadyHandler();
					replaceAgentContactSuccessMessage();
				} );
				$( window ).on( 'resize', function() {
					clearTimeout( resizeTimer );
					resizeTimer = setTimeout( function() {
						initScrollbarForPropertyListings();
						setTab1MinHeight();
						setMapCanvasHeight();
						adjustThumbnailsVisibilityAndLightboxHeight();
						showOrHideSearchPlaceholder();
						activateOrDeactivateVerticalSlider();
					}, 50 );
				} );
			},
			finalize: function finalize() {
				var formValidationEngine = function formValidationEngine() {
					$( "#aubrey-login-form" ).validationEngine( 'attach', {
						scroll: false,
						promptPosition: "topRight:-100",
						maxErrorsPerField: 1
					} );
					$( "#aubrey-registration-form" ).validationEngine( 'attach', {
						scroll: false,
						promptPosition: "topRight:-100",
						maxErrorsPerField: 1
					} );
					$( "#aubrey-forgot-password-form" ).validationEngine( 'attach', {
						scroll: false,
						promptPosition: "topRight:-100",
						maxErrorsPerField: 1
					} );
					$( "#aubrey-reset-password-form" ).validationEngine( 'attach', {
						scroll: false,
						promptPosition: "topRight:-100",
						maxErrorsPerField: 1
					} );
					$( "#aubrey-save-filter-form" ).validationEngine( 'attach', {
						scroll: false,
						promptPosition: "topRight:-100",
						maxErrorsPerField: 1
					} );
					$( ".wpcf7-form" ).validationEngine( 'attach', {
						scroll: false,
						promptPosition: "topRight:-100",
						maxErrorsPerField: 1
					} );
					$( "#lidd_mc_form" ).validationEngine( 'attach', {
						scroll: false,
						promptPosition: "topRight:-100",
						maxErrorsPerField: 1
					} );
					$( '.aubreyguri-property-contact-form' ).validationEngine( 'attach', {
						scroll: false,
						focusFirstField: false,
						promptPosition: "topRight:-100",
						maxErrorsPerField: 1
          } );
          $('.global-signup-form form').validationEngine('attach', {
						scroll: false,
						promptPosition: "topRight:-100",
            maxErrorsPerField: 1
          });
				};
				formValidationEngine();
			}
		},
		// Home page
		'home': {
			init: function init() {
				// JavaScript to be fired on the home page
				var resizeTimer;

				var activateOrDeactivateHomeBannerSlider = function activateOrDeactivateHomeBannerSlider() {
					var $bannerSlider = $( '.banner__slider' );
					var navsToggler = document.querySelector( '.header__navs-toggler' );
					var navsTogglerDisplay = getComputedStyle( navsToggler ).display;

					if ( $bannerSlider.hasClass( 'slick-initialized' ) && navsTogglerDisplay === 'flex' ) {
						$bannerSlider.slick( 'unslick' );
					} else if ( !$bannerSlider.hasClass( 'slick-initialized' ) && navsTogglerDisplay === 'none' ) {
						$bannerSlider.slick( {
							autoplay: false,
							rows: 0,
							autoplaySpeed: 5000,
							slidesToShow: 5,
							appendArrows: '.banner',
							prevArrow: '.banner__slider-nav-button--prev',
							nextArrow: '.banner__slider-nav-button--next'
						} );
					}
				};

				var shiftBannerSliderOnSlideHover = function shiftBannerSliderOnSlideHover() {
					var bannerSlider = document.querySelector( '.banner__slider' );

					if ( !bannerSlider ) {
						return;
					}

					$( '.banner__slide' ).each( function(i, slide ) {
						slide.addEventListener( 'mouseenter', function() {
							//bannerSlider.classList.add( 'shift-left' );
						} );
						slide.addEventListener( 'mouseleave', function() {
							//bannerSlider.classList.remove( 'shift-left' );
						} );
					} );
				};

				activateOrDeactivateHomeBannerSlider();
				shiftBannerSliderOnSlideHover();

				$( '.home-vertical-slider__specialties' ).mCustomScrollbar( {
					scrollbarPosition: 'outside',
					alwaysShowScrollbar: 0,
					scrollButtons: {
						enable: true
					},
					keyboard: {
						enable: true
					},
					theme: 'inset-dark'
        } );
        
        $('.home-vertical-slider__specialty-link.has-brief-write-up').on('click', function(e) {
          e.preventDefault();
          var $this = $(this);
          if ($this.attr('aria-expanded') === 'false') {
            $this.attr('aria-expanded', 'true')
              .next('.home-vertical-slider__specialty-brief-write-up')
                .slideDown();
          } else {
            $this.attr('aria-expanded', 'false')
              .next('.home-vertical-slider__specialty-brief-write-up')
                .slideUp();
          }
        });

				window.addEventListener( 'resize', function() {
					clearTimeout( resizeTimer );
					resizeTimer = setTimeout( function() {
						activateOrDeactivateHomeBannerSlider();
					}, 100 );
				} );
			},
			finalize: function finalize() {// JavaScript to be fired on the home page, after the init JS
				function getUrls() {
					var urlRegExp = /url\(('|")?([^'"()]+)('|")\)?/;
					var urls = [];

					for (var i = 0; i < document.styleSheets.length; i++) {
						var cssRules = document.styleSheets[i].cssRules;

						for (var j = 0; j < cssRules.length; j++) {
							var cssRule = cssRules[j];

							if (!cssRule.selectorText) {
								continue;
							}

							for (var k = 0; k < cssRule.style.length; k++) {
								var property = cssRule.style[k],
									urlMatch = cssRule.style[property].match(urlRegExp);

								if (urlMatch !== null) {
									urls.push(urlMatch[2]);
								}
							}
						}
					}

					return urls;
				}

				function preloadImages() {
					return new Promise(function (resolve) {
						var urls = getUrls(),
							loadedCount = 0;

						var onImageLoad = function onImageLoad() {
							loadedCount++;

							if (urls.length === loadedCount) {
								resolve();
							}
						};

						for (var i = 0; i < urls.length; i++) {
							var image = new Image();
							image.src = urls[i];
							image.onload = onImageLoad;
						}
					});
				}

				document.addEventListener('DOMContentLoaded', function () {
					preloadImages().then(function () {// CSS images are loaded here
					});
				});
			}
		},
		'sell_with_us_on_social_media': {
			init: function init() {

			},
			finalize: function finalize() {// JavaScript to be fired on the home page, after the init JS
			}
    },
    'calculate_your_homes_value': {
      init: function init() {
				var initPropertyValueCalculator = function initPropertyValueCalculator() {
					var inputLabel = $( '.property-value-calculator-input label' );
					var inputField = $( '.property-value-calculator-input input[type="text"], .property-value-calculator-input input[type="email"], .property-value-calculator-input textarea' );

					inputField.val( '' );

					inputLabel.click( function() {
						$( this ).parent().find( 'input, textarea' ).focus();
					} );

					inputField.focus( function() {
						$( this ).closest('.property-value-calculator-input').find( 'label' ).addClass( 'move-placeholder-at-top' );
					} );

					inputField.blur( function() {
						var $this = $( this );
						if ( $this.val().length == 0 ) {
							$( this ).closest('.property-value-calculator-input').find( 'label' ).removeClass( 'move-placeholder-at-top' );
						}
					} );

					inputField.blur();
        };
        
        var toggleCheckboxesDropdown = function toggleCheckboxesDropdown() {
          $('.property-value-calculator-dropdown-toggle').on('click', function() {
            var $toggleButton = $(this);
            if ($toggleButton.attr('aria-expanded') === 'false') {
              $toggleButton.next('.property-value-calculator-checkboxes').slideDown();
              $toggleButton.attr('aria-expanded', 'true');
            } else {
              $toggleButton.next('.property-value-calculator-checkboxes').slideUp();
              $toggleButton.attr('aria-expanded', 'false');
            }
          });
        };

        var checkboxesChangeHandler = function checkboxesChangeHandler() {
          $('.property-value-calculator-checkbox-group [type="checkbox"]').on('change', function() {
            var $checkbox = $(this);
            var name = $checkbox.attr('name');
            var checkedValues = [];
            $('[name="' + name + '"]:checked').each(function(i, checkedCheckbox) {
              checkedValues.push(checkedCheckbox.value);
            });

            var checkedValuesStr = checkedValues.join(', ');
            $checkbox.closest('.property-value-calculator-checkboxes').find('[type="hidden"]').val(checkedValuesStr);
          });
        };

        var radioChangeHandler = function radioChangeHandler() {
          $('.property-value-calculator-radio-group [type="radio"]').on('change', function() {
            var $radio = $(this);
            var name = $radio.attr('name');
            var checkedValue = $('[name="' + name + '"]:checked').val();
            $radio.closest('.property-value-calculator-checkboxes').find('[type="hidden"]').val(checkedValue);
          });
        };

        var resetFormOnMailSent = function resetFormOnMailSent() {
          $('.property-value-calculator .wpcf7' ).on('wpcf7mailsent', function() {
            var $this = $(this);
            $this.find('input[type="text"], input[type="email"], input[type="number"], textarea').val('')
              .closest('.property-value-calculator-input').find('label').removeClass('move-placeholder-at-top');
            $this.find('input:checked').prop('checked', false);
            $this.find('.property-value-calculator-dropdown-toggle[aria-expanded="true"]').attr('aria-expanded', 'false')
              .next('.property-value-calculator-checkboxes')
                .slideUp();
          });
        };

        initPropertyValueCalculator();
        toggleCheckboxesDropdown();
        checkboxesChangeHandler();
        radioChangeHandler();
        resetFormOnMailSent();
      }
    },
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function init() {// JavaScript to be fired on the about us page
			}
		},
		'featured_property': {
			init: function init() {
				var initMainPropertiesSlider = function initMainPropertiesSlider() {
					$( '.main__properties-slider' ).slick( {
						autoplay: true,
						autoplaySpeed: 5000
					} );
				};

				initMainPropertiesSlider();
			}
		},
		'exclusive_preview': {
			init: function init() {
				var subscription_btn = null;
				if ( '1' === sage_loadmore_params.is_logged_in ) {
					if ( '1' === sage_loadmore_params.newsletter_confirmation ) {
						subscription_btn = '<a data-channel="logged-in" data-action="0" href="" class="button button--olive-ghost button--unsubscribe aubreyguri-newsletter-action">Click here to unsubscribe</a>';
					} else {
						subscription_btn = '<a data-channel="logged-in" data-action="1" href="" class="button button--olive-ghost button--subscribe aubreyguri-newsletter-action">Click here to subscribe</a>';
					}

				} else {
					subscription_btn = '<a data-channel="not-logged-in" data-action="1" href="" class="button button--olive-ghost button--subscribe aubreyguri-newsletter-action">Click here to subscribe</a>';
				}


				$( '.main__heading' ).html(function(i, html) {
          return '<div style="width: 40.1rem; height: 0.1rem;"></div><div class="main__heading-content" style="margin: 0 1rem;">' + html + '</div>' + subscription_btn;
        }).css({
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        });
			
        var initMainPropertiesSlider = function initMainPropertiesSlider() {
          $( '.main__properties-slider' ).slick( {
            autoplay: true,
            autoplaySpeed: 5000
          } );
        };

        initMainPropertiesSlider();
      },
		},
		'page_template_template_why_list_with_aubrey': {
			init: function init() {
				var initMainTestimonialSlider = function initMainTestimonialSlider() {
					$( '.testimonial-slider' ).slick( {
						autoplay: true,
						autoplaySpeed: 5000,
						fade: true,
						appendArrows: '.testimonials',
						prevArrow: '.testimonial__slider-nav-button--prev',
						nextArrow: '.testimonial__slider-nav-button--next'
					} );

					$( '.testimonial__slider-nav-button' ).on( 'click', function() {
						$( '.testimonial-slider' ).slick( "slickSetOption", "autoplay", false, true );
					} );

					if ( $( window ).width() < 768 ) {
						$( '.testimonial-slider' ).slick( "slickSetOption", "adaptiveHeight", true, true );
					}

        };
        
        var adjustHeight = function adjustHeight() {
          var $whyListSlider = $('.why-list-with-aubrey-vertical-slider');
          var sliderHeight = $whyListSlider.find('.inner-page-vertical-slider__slide--3>.inner-page-vertical-slider__col--1').height();
          $whyListSlider.find('.inner-page-vertical-slider__col--1').height(sliderHeight);
          $whyListSlider.find('.inner-page-vertical-slider__text-content.mCustomScrollbar').css('max-height', (sliderHeight - 261) + 'px')
        };

        initMainTestimonialSlider();
        adjustHeight();

				$('#v-pills-select').on('change', function (e) {
					var tabIndex = $(this).val();
					$('#v-pills-tab-'+ tabIndex).click();
				});

			}
		},
		'real_estate_agent_reviews_ny': {
			init: function init() {
				var timer;
				$( '.content-box__col--right' ).mCustomScrollbar( {
					scrollbarPosition: 'outside',
					alwaysShowScrollbar: 0,
					scrollButtons: {
						enable: true
					},
					keyboard: {
						enable: true
					},
					theme: 'inset-dark'
				} );

				window.addEventListener( 'resize', function() {
					clearTimeout( timer );
					timer = setTimeout( function() {//ps.update();
					}, 50 );
				} );

				var initMainTestimonialSlider = function initMainTestimonialSlider() {
					$( '.testimonial-slider' ).slick( {
						autoplay: true,
						autoplaySpeed: 5000,
						appendArrows: '.testimonials',
						fade: true,
						prevArrow: '.testimonial__slider-nav-button--prev',
						nextArrow: '.testimonial__slider-nav-button--next'
					} );

					if ( $( window ).width() < 768 ) {
						$( '.testimonial-slider' ).slick( "slickSetOption", "adaptiveHeight", true, true );
					}
				};

				initMainTestimonialSlider();
			}
		},
		'wpl_property_listing': {
			init: function init() {

			}
		},
		'aubreys_on_the_cover_of_top_agent_magazine': {
			init: function init() {
				var timer;
				$( '.content-box__col--right' ).mCustomScrollbar( {
					scrollbarPosition: 'outside',
					alwaysShowScrollbar: 0,
					scrollButtons: {
						enable: true
					},
					keyboard: {
						enable: true
					},
					theme: 'inset-dark'
				} );
				window.addEventListener( 'resize', function() {
					clearTimeout( timer );
					timer = setTimeout( function() {//ps.update();
					}, 50 );
				} );
			}
		},
		'favorites': {
			init: function init() {
				var timer;
				$( '.horizontal-properties-content-box__row' ).mCustomScrollbar( {
					scrollbarPosition: 'outside',
					axis: "x",
					alwaysShowScrollbar: 0,
					scrollButtons: {
						enable: true
					},
					keyboard: {
						enable: true
					},
					theme: 'inset-dark'
				} );
				window.addEventListener( 'resize', function() {
					clearTimeout( timer );
					timer = setTimeout( function() {//ps.update();
					}, 50 );
				} );
			}
		},
		'our_team': {
			init: function init() {
				var timer;
				$( 'body' ).on( 'click', '.team_member_content-box--link', function() {
					$( 'body' ).fadeOut();
				} );

				$( '.horizontal-content-box__row' ).mCustomScrollbar( {
					scrollbarPosition: 'outside',
					axis: "x",
					alwaysShowScrollbar: 0,
					scrollButtons: {
						enable: true
					},
					keyboard: {
						enable: true
					},
					theme: 'inset-dark'
				} );
				window.addEventListener( 'resize', function() {
					clearTimeout( timer );
					timer = setTimeout( function() {//ps.update();
					}, 50 );
				} );
			}
		},
		'page_template_template_team_member': {
			init: function init() {
				var timer;
				$( '.content-box__col--right' ).mCustomScrollbar( {
					scrollbarPosition: 'outside',
					alwaysShowScrollbar: 0,
					scrollButtons: {
						enable: true
					},
					keyboard: {
						enable: true
					},
					theme: 'inset-dark'
				} );
				window.addEventListener( 'resize', function() {
					clearTimeout( timer );
					timer = setTimeout( function() {//ps.update();
					}, 50 );
				} );
			},
			finalize: function finalize() {

			}
		},
		'list_your_saratoga_real_estate_with_aubrey': {
			init: function init() {
				var timer;
				$( '.content-box__col--right' ).mCustomScrollbar( {
					scrollbarPosition: 'outside',
					alwaysShowScrollbar: 0,
					scrollButtons: {
						enable: true
					},
					keyboard: {
						enable: true
					},
					theme: 'inset-dark'
				} );

				window.addEventListener( 'resize', function() {
					clearTimeout( timer );
					timer = setTimeout( function() {//ps.update();
					}, 50 );
				} );

				var initMainTestimonialSlider = function initMainTestimonialSlider() {
					$( '.testimonial-slider' ).slick( {
						autoplay: true,
						autoplaySpeed: 5000,
						appendArrows: '.testimonials',
						fade: true,
						prevArrow: '.testimonial__slider-nav-button--prev',
						nextArrow: '.testimonial__slider-nav-button--next'
					} );

					if ( $( window ).width() < 768 ) {
						$( '.testimonial-slider' ).slick( "slickSetOption", "adaptiveHeight", true, true );
					}
				};

				initMainTestimonialSlider();

				/*var $meetAubreyGuriSlides = $( '.meet-aubrey-guri-vertical-slider > .vertical-slider-inner' );
				var $meetAubreyGuriSlideDisplay = $meetAubreyGuriSlides.find( '.inner-page-vertical-slider__slide' ).last().css( 'display' );

				if ($meetAubreyGuriSlideDisplay === 'block' ) {
          if ($meetAubreyGuriSlides.hasClass('slick-initialized')) {
            $meetAubreyGuriSlides.slick('unslick');
          }
				} else if ( !$meetAubreyGuriSlides.hasClass( 'slick-initialized' ) ) {
					$meetAubreyGuriSlides.slick( {
						arrows: false,
						fade: true,
						speed: 700,
					} );
				}*/

				$( document ).on( "click", '.meet-aubrey-guri-slides-nav-button--panel-flip', function( e ) {
					e.preventDefault();
					$( this ).closest( '.meet-aubrey-guri-slider-nav' ).prev( '.meet-aubrey-guri-slides' ).slick( 'slickNext' );
				} );

				$( '.meet-aubrey-guri-slides' ).on( 'afterChange', function( event, slick, currentSlide ) {

					$( '.flip-panel-dots > li' ).removeClass( 'flip-active' )
						.filter( '[data-id="' + (currentSlide + 1) + '"]' )
						.addClass( 'flip-active' );
				} );

				$( document ).on( "click", '.meet-aubrey-guri-slides-container .panel-flip', function( e ) {
					e.preventDefault();
					$( this ).closest( '.meet-aubrey-guri-slides-container' ).prev( '.meet-aubrey-guri-slides' ).slick( 'slickNext' );
				} );

				$( document ).on( "click", '.meet-aubrey-guri-slides-container .flip-panel-dots button', function() {
					$( this ).closest( '.meet-aubrey-guri-slides-container' ).find( '.meet-aubrey-guri-slides' ).slick( 'slickGoTo', +$( this ).parent().data( 'id' ) - 1 );
				} );

			}
		},
		'mortgage_calculator': {
			init: function init() {

			}
		},
		'edit_account': {
			init: function init() {
				var inputLabel = $( '.form-group label' );
				var inputField = $( '.form-group input[type="text"], .form-group input[type="email"], .form-group input[type="password"]' );

				inputLabel.click( function() {
					$( this ).parent().find( 'input' ).focus();
				} );

				inputField.focus( function() {
					$( this ).parent().find( 'label' ).addClass( 'move-placeholder-at-top' );
				} );

				inputField.blur( function() {
					var $this = $( this );
					if ( $this.val().length == 0 ) {
						$( this ).parent().find( 'label' ).removeClass( 'move-placeholder-at-top' );
					} else {
						$( this ).parent().find( 'label' ).addClass( 'move-placeholder-at-top' );
					}
				} );

				inputField.blur();
			}
		},
		'preferred_mortgage_professional': {
			init: function init() {
				var timer;
				$( '.content-box__col--right' ).mCustomScrollbar( {
					scrollbarPosition: 'outside',
					alwaysShowScrollbar: 0,
					scrollButtons: {
						enable: true
					},
					keyboard: {
						enable: true
					},
					theme: 'inset-dark'
				} );
				window.addEventListener( 'resize', function() {
					clearTimeout( timer );
					timer = setTimeout( function() {//ps.update();
					}, 50 );
				} );
			}
		},
		'wpl_property_show_default': {
			init: function init() {
				$( 'h2.main__heading' ).remove();
			}
		},
	}; // The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event

	var UTIL = {
		fire: function fire( func, funcname, args ) {
			var fire;
			var namespace = Sage;
			funcname = funcname === undefined ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[ func ];
			fire = fire && typeof namespace[ func ][ funcname ] === 'function';

			if ( fire ) {
				namespace[ func ][ funcname ]( args );
			}
		},
		loadEvents: function loadEvents() {
			// Fire common init JS
			UTIL.fire( 'common' ); // Fire page-specific init JS, and then finalize JS

			$.each( document.body.className.replace( /-/g, '_' ).split( /\s+/ ), function( i, classnm ) {
				UTIL.fire( classnm );
				UTIL.fire( classnm, 'finalize' );
			} ); // Fire common finalize JS

			UTIL.fire( 'common', 'finalize' );
		}
	}; // Load Events

	$( document ).ready( UTIL.loadEvents );
})( jQuery ); // Fully reference jQuery after this point.